// GENERATED by `python scripts/engine.py sync-app` from process/steps.yaml and process/status.yaml.
// Do not edit by hand: change the YAML, run the command and commit both. CI checks they agree.
import type { ProcessData } from "./process";

export const PROCESS: ProcessData = {
  "version": 3,
  "updated": "2026-10-10",
  "phases": [
    {
      "key": "P0",
      "name": "Set up the business",
      "description": "Get the business ready once. Agree the playbook, connect the accounts and set up the website, domains and newsletter."
    },
    {
      "key": "P1",
      "name": "Attract (inbound)",
      "description": "Bring people to you. Articles, posts, video, listings, the newsletter, ads and the website each end in a traceable call to action that hands the enquiry to Connect."
    },
    {
      "key": "P2",
      "name": "Source (outbound and referral)",
      "description": "Find firms worth contacting, from registers, filings, news, tenders, referrers and directories."
    },
    {
      "key": "P3",
      "name": "Enrich and score",
      "description": "Find the right person at each firm, check their details, research the firm and score how good a fit it is."
    },
    {
      "key": "P4",
      "name": "Contact",
      "description": "Reach out. Pick the channels, write the messages, get your approval and send them within the daily caps."
    },
    {
      "key": "P5",
      "name": "Listen",
      "description": "Catch every reply, open, click and visit, match it to the right person and update their score."
    },
    {
      "key": "P6",
      "name": "Qualify and respond",
      "description": "Read each reply, decide what it means and answer it, or hand it to you when it is unclear."
    },
    {
      "key": "P7",
      "name": "Book",
      "description": "Agree a time, put the meeting in the calendar and send the pre-read and reminder."
    },
    {
      "key": "P8",
      "name": "Meet",
      "description": "Brief you before the meeting, check it happened and capture the notes and next steps."
    },
    {
      "key": "P9",
      "name": "Convert",
      "description": "Turn a good meeting into a deal. Your way of quoting, then the offer and decision, with you approving the offer, and one save offer when the first answer is no."
    },
    {
      "key": "P10",
      "name": "Nurture, refer and learn",
      "description": "Stay in touch with everyone not ready yet, make offers matched to why they did not buy, bring them back into Connect when their interest returns, ask for referrals and learn what works."
    },
    {
      "key": "E",
      "name": "Engine room",
      "description": "The plumbing that keeps it all running safely. Schedules, alerts, caps, data rules and checks."
    }
  ],
  "owners": {
    "strategy-agent": "Drafts the playbook for each business",
    "content-agent": "Runs the content engine and website",
    "social-agent": "Researches what works on social, plans, drafts and schedules posts, and learns from results",
    "listings-agent": "Gets the business found - master record, listings, consistency, reviews and mentions",
    "sourcing-agent": "Finds new leads and signals",
    "enrichment-agent": "Finds people, contacts and scores",
    "outreach-agent": "Picks channels, writes copy, sends touches",
    "inbox-agent": "Catches, matches, classifies and answers every inbound message",
    "scheduler-agent": "Books, reminds and rebooks meetings",
    "deal-agent": "Prepares meetings, captures outcomes, runs conversion",
    "relationship-agent": "Nurture, referrals and referrers",
    "ops-agent": "Plumbing, monitoring, metrics, experiments, playbook updates",
    "supervisor": "Talks to the human, dispatches tasks, answers questions, produces exports",
    "human": "Human gates only"
  },
  "steps": [
    {
      "id": "0.R",
      "phase": "P0",
      "kind": "crm_read",
      "verb": "Create workspace",
      "tool": "CRM API",
      "owner": "ops-agent",
      "crm": "crm_create_tenant",
      "status": "tested"
    },
    {
      "id": "0.1",
      "phase": "P0",
      "kind": "action",
      "verb": "Define ideal customer",
      "tool": "Claude",
      "owner": "strategy-agent",
      "crm": "crm_register_document",
      "status": "built"
    },
    {
      "id": "0.2",
      "phase": "P0",
      "kind": "action",
      "verb": "Write offer and lead magnet",
      "tool": "Claude",
      "owner": "strategy-agent",
      "crm": "crm_register_document",
      "status": "built"
    },
    {
      "id": "0.3",
      "phase": "P0",
      "kind": "action",
      "verb": "Write voice and objection library",
      "tool": "Claude",
      "owner": "strategy-agent",
      "crm": "crm_register_document",
      "status": "built"
    },
    {
      "id": "0.4",
      "phase": "P0",
      "kind": "action",
      "verb": "Record compliance basis",
      "tool": "Claude",
      "owner": "strategy-agent",
      "crm": "crm_propose_config",
      "status": "built"
    },
    {
      "id": "0.5",
      "phase": "P0",
      "kind": "action",
      "verb": "Approve playbook",
      "tool": "Claude Docs",
      "owner": "human",
      "human": true,
      "crm": "crm_decide_config",
      "status": "tested"
    },
    {
      "id": "0.6",
      "phase": "P0",
      "kind": "action",
      "verb": "Buy sending domains",
      "tool": "Cloudflare",
      "owner": "ops-agent",
      "crm": "crm_upsert_mailbox",
      "when": "$.tools ? (@.email_sending == \"instantly\")",
      "status": "built"
    },
    {
      "id": "0.7",
      "phase": "P0",
      "kind": "action",
      "verb": "Authenticate domains",
      "tool": "DNS checker",
      "owner": "ops-agent",
      "crm": "crm_record_domain_auth",
      "status": "tested"
    },
    {
      "id": "0.8",
      "phase": "P0",
      "kind": "action",
      "verb": "Warm up inboxes",
      "tool": "Instantly",
      "owner": "ops-agent",
      "crm": "crm_upsert_mailbox",
      "when": "$.tools ? (@.email_sending == \"instantly\")",
      "status": "tested"
    },
    {
      "id": "0.9",
      "phase": "P0",
      "kind": "action",
      "verb": "Build website",
      "tool": "Cloudflare Pages",
      "alternatives": [
        "Framer"
      ],
      "owner": "content-agent",
      "status": "built"
    },
    {
      "id": "0.10",
      "phase": "P0",
      "kind": "action",
      "verb": "Build lead magnet",
      "tool": "Tally",
      "owner": "content-agent",
      "status": "built"
    },
    {
      "id": "0.11",
      "phase": "P0",
      "kind": "action",
      "verb": "Set up newsletter",
      "tool": "Resend",
      "alternatives": [
        "Beehiiv"
      ],
      "owner": "content-agent",
      "when": "$.lead_sources.inbound ? (@.newsletter == true)",
      "status": "built"
    },
    {
      "id": "0.12",
      "phase": "P0",
      "kind": "action",
      "verb": "Connect social profiles",
      "tool": "Meta (Facebook Login for Business)",
      "alternatives": [
        "Instagram Login",
        "Buffer"
      ],
      "owner": "social-agent",
      "crm": "crm_record_meta_assets",
      "status": "built"
    },
    {
      "id": "0.13",
      "phase": "P0",
      "kind": "action",
      "verb": "Capture brand",
      "tool": "Website crawler",
      "alternatives": [
        "Claude"
      ],
      "owner": "content-agent",
      "status": "built"
    },
    {
      "id": "0.14",
      "phase": "P0",
      "kind": "action",
      "verb": "Check web presence",
      "tool": "Website crawler",
      "owner": "ops-agent",
      "crm": "crm_register_document",
      "status": "built"
    },
    {
      "id": "0.15",
      "phase": "P0",
      "kind": "action",
      "verb": "Prepare business identity",
      "tool": "Claude",
      "owner": "ops-agent",
      "crm": "crm_register_document",
      "status": "built"
    },
    {
      "id": "0.16",
      "phase": "P0",
      "kind": "action",
      "verb": "Install consent and tracking",
      "tool": "Website snippet",
      "owner": "content-agent",
      "check": "PECR consent",
      "when": "$.lead_sources.inbound ? (@.website == true)",
      "status": "built"
    },
    {
      "id": "0.17",
      "phase": "P0",
      "kind": "action",
      "verb": "Set up ad accounts",
      "tool": "Meta Business",
      "alternatives": [
        "Google Ads"
      ],
      "owner": "ops-agent",
      "when": "$.channels.ads ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "0.18",
      "phase": "P0",
      "kind": "action",
      "verb": "Capture website brief",
      "tool": "Claude",
      "owner": "content-agent",
      "crm": "crm_register_document",
      "next": "0.20",
      "status": "built"
    },
    {
      "id": "0.19",
      "phase": "P0",
      "kind": "action",
      "verb": "Import existing website",
      "tool": "Website crawler",
      "owner": "content-agent",
      "next": "0.20",
      "status": "built"
    },
    {
      "id": "0.20",
      "phase": "P0",
      "kind": "action",
      "verb": "Draft website",
      "tool": "Claude",
      "alternatives": [
        "Website studio"
      ],
      "owner": "content-agent",
      "next": "0.21",
      "status": "built"
    },
    {
      "id": "0.21",
      "phase": "P0",
      "kind": "action",
      "verb": "Approve and publish website",
      "tool": "Website studio",
      "owner": "human",
      "human": true,
      "next": "0.22",
      "status": "built"
    },
    {
      "id": "0.22",
      "phase": "P0",
      "kind": "action",
      "verb": "Connect domain",
      "tool": "Cloudflare Pages",
      "owner": "ops-agent",
      "crm": "crm_register_site",
      "status": "built"
    },
    {
      "id": "0.23",
      "phase": "P0",
      "kind": "action",
      "verb": "Confirm business record",
      "tool": "Claude",
      "owner": "listings-agent",
      "when": "$.listings ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "0.24",
      "phase": "P0",
      "kind": "action",
      "verb": "Set engine schedule",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "status": "built"
    },
    {
      "id": "0.25",
      "phase": "P0",
      "kind": "action",
      "verb": "Check website install",
      "tool": "Website crawler",
      "owner": "ops-agent",
      "status": "built"
    },
    {
      "id": "0.26",
      "phase": "P0",
      "kind": "action",
      "verb": "Learn voice from sent mail",
      "tool": "Gmail API",
      "owner": "ops-agent",
      "crm": "crm_propose_config",
      "when": "$.voice ? (@.learn_from_sent_mail == true)",
      "status": "built"
    },
    {
      "id": "0.27",
      "phase": "P0",
      "kind": "action",
      "verb": "Read who you already know",
      "tool": "Gmail API",
      "owner": "inbox-agent",
      "crm": "crm_add_known_contacts",
      "status": "built"
    },
    {
      "id": "0.28",
      "phase": "P0",
      "kind": "action",
      "verb": "Import your contacts",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_import_contacts",
      "status": "built"
    },
    {
      "id": "0.29",
      "phase": "P0",
      "kind": "action",
      "verb": "Sync your other CRM",
      "tool": "HubSpot",
      "alternatives": [
        "Pipedrive"
      ],
      "owner": "sourcing-agent",
      "crm": "crm_import_contacts",
      "status": "built"
    },
    {
      "id": "0.30",
      "phase": "P0",
      "kind": "action",
      "verb": "Connect WhatsApp number",
      "tool": "Meta Embedded Signup",
      "alternatives": [
        "360dialog"
      ],
      "owner": "human",
      "human": true,
      "crm": "crm_connect_whatsapp",
      "when": "$.channels.whatsapp ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "0.31",
      "phase": "P0",
      "kind": "action",
      "verb": "Approve WhatsApp templates",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_decide_whatsapp_template",
      "when": "$.channels.whatsapp ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "0.35",
      "phase": "P0",
      "kind": "action",
      "verb": "Read your website",
      "tool": "Claude",
      "owner": "strategy-agent",
      "crm": "crm_save_core",
      "status": "built"
    },
    {
      "id": "0.36",
      "phase": "P0",
      "kind": "action",
      "verb": "Confirm your business core",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_save_core",
      "status": "built"
    },
    {
      "id": "0.37",
      "phase": "P0",
      "kind": "action",
      "verb": "Choose your route",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_set_route",
      "status": "built"
    },
    {
      "id": "0.38",
      "phase": "P0",
      "kind": "action",
      "verb": "Choose modules and parts",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_set_module_state",
      "status": "built"
    },
    {
      "id": "0.39",
      "phase": "P0",
      "kind": "action",
      "verb": "Approve a play",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_play_decide",
      "status": "built"
    },
    {
      "id": "0.40",
      "phase": "P0",
      "kind": "action",
      "verb": "Import past conversations from your other CRM",
      "tool": "HubSpot",
      "alternatives": [
        "Pipedrive"
      ],
      "owner": "sourcing-agent",
      "crm": "crm_import_interactions",
      "status": "built"
    },
    {
      "id": "0.41",
      "phase": "P0",
      "kind": "action",
      "verb": "Import past email conversations",
      "tool": "Gmail API",
      "alternatives": [
        "Microsoft 365"
      ],
      "owner": "inbox-agent",
      "crm": "crm_import_interactions",
      "status": "built"
    },
    {
      "id": "0.42",
      "phase": "P0",
      "kind": "action",
      "verb": "Import WhatsApp chats",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_add_history_upload",
      "status": "built"
    },
    {
      "id": "0.43",
      "phase": "P0",
      "kind": "action",
      "verb": "Summarise each relationship",
      "tool": "Claude",
      "owner": "relationship-agent",
      "crm": "crm_set_relationship_summary",
      "status": "built"
    },
    {
      "id": "0.44",
      "phase": "P0",
      "kind": "action",
      "verb": "Start the business again",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_reset_tenant",
      "status": "built"
    },
    {
      "id": "0.45",
      "phase": "P0",
      "kind": "action",
      "verb": "Add or edit a contact by hand",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_add_contact",
      "status": "tested"
    },
    {
      "id": "0.46",
      "phase": "P0",
      "kind": "action",
      "verb": "Note the latest with a person",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_note_latest",
      "status": "tested"
    },
    {
      "id": "0.47",
      "phase": "P0",
      "kind": "engine",
      "verb": "Log interactions from mail and calendar",
      "tool": "Gmail",
      "alternatives": [
        "Microsoft Graph"
      ],
      "owner": "inbox-agent",
      "crm": "crm_log_interactions",
      "status": "built"
    },
    {
      "id": "0.48",
      "phase": "P0",
      "kind": "action",
      "verb": "Set up a campaign",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_campaign_add, crm_campaign_link",
      "status": "tested"
    },
    {
      "id": "0.49",
      "phase": "P0",
      "kind": "crm_read",
      "verb": "Show the accounts Connect needs",
      "tool": "CRM screens",
      "owner": "human",
      "crm": "crm_onboarding_checklist",
      "status": "built"
    },
    {
      "id": "0.W",
      "phase": "P0",
      "kind": "crm_write",
      "verb": "Apply settings",
      "tool": "CRM API",
      "owner": "ops-agent",
      "crm": "crm_apply_config",
      "status": "tested"
    },
    {
      "id": "1.R",
      "phase": "P1",
      "kind": "crm_read",
      "verb": "Read engaged accounts",
      "tool": "Claude CRM connector",
      "owner": "content-agent",
      "crm": "crm_content_brief",
      "status": "built"
    },
    {
      "id": "1.1",
      "phase": "P1",
      "kind": "action",
      "verb": "Collect market insights",
      "tool": "News sweep",
      "owner": "content-agent",
      "crm": "crm_record_insight",
      "status": "built"
    },
    {
      "id": "1.2",
      "phase": "P1",
      "kind": "action",
      "verb": "Draft pillar article",
      "tool": "Claude",
      "owner": "content-agent",
      "crm": "crm_plan_content",
      "status": "built"
    },
    {
      "id": "1.3",
      "phase": "P1",
      "kind": "action",
      "verb": "Fact-check article",
      "tool": "Claude",
      "owner": "content-agent",
      "crm": "crm_record_fact_check",
      "next": "1.21",
      "status": "tested"
    },
    {
      "id": "1.4",
      "phase": "P1",
      "kind": "action",
      "verb": "Cut into posts",
      "tool": "Claude",
      "owner": "social-agent",
      "crm": "crm_plan_content",
      "next": "1.19",
      "status": "built"
    },
    {
      "id": "1.5",
      "phase": "P1",
      "kind": "action",
      "verb": "Create visuals",
      "tool": "Claude",
      "alternatives": [
        "Canva"
      ],
      "owner": "content-agent",
      "crm": "crm_attach_content_asset",
      "status": "built"
    },
    {
      "id": "1.6",
      "phase": "P1",
      "kind": "action",
      "verb": "Schedule social posts",
      "tool": "Meta Graph API",
      "alternatives": [
        "Buffer"
      ],
      "owner": "social-agent",
      "crm": "crm_mark_content_scheduled",
      "next": "1.22",
      "status": "built"
    },
    {
      "id": "1.7",
      "phase": "P1",
      "kind": "action",
      "verb": "Publish blog post",
      "tool": "Cloudflare Pages",
      "alternatives": [
        "WordPress",
        "Webflow",
        "Shopify",
        "Wix",
        "Ghost",
        "Framer"
      ],
      "owner": "content-agent",
      "crm": "crm_mark_content_published",
      "status": "built"
    },
    {
      "id": "1.8",
      "phase": "P1",
      "kind": "action",
      "verb": "Structure for AI search",
      "tool": "Claude",
      "owner": "content-agent",
      "crm": "crm_set_content_meta",
      "status": "built"
    },
    {
      "id": "1.9",
      "phase": "P1",
      "kind": "action",
      "verb": "Send newsletter",
      "tool": "Resend",
      "alternatives": [
        "Beehiiv"
      ],
      "owner": "content-agent",
      "crm": "crm_subscribe",
      "when": "$.lead_sources.inbound ? (@.newsletter == true)",
      "status": "built"
    },
    {
      "id": "1.10",
      "phase": "P1",
      "kind": "action",
      "verb": "Run retargeting ads",
      "tool": "Meta Ads",
      "alternatives": [
        "Google Ads",
        "LinkedIn Ads"
      ],
      "owner": "content-agent",
      "when": "$.channels.ads ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.11",
      "phase": "P1",
      "kind": "action",
      "verb": "Identify site visitors",
      "tool": "Dealfront",
      "owner": "inbox-agent",
      "check": "GDPR notice",
      "crm": "crm_capture_visit",
      "when": "$.lead_sources.inbound ? (@.website == true)",
      "status": "built"
    },
    {
      "id": "1.12",
      "phase": "P1",
      "kind": "action",
      "verb": "Qualify visitor in chat",
      "tool": "Chat widget",
      "owner": "inbox-agent",
      "status": "built"
    },
    {
      "id": "1.13",
      "phase": "P1",
      "kind": "action",
      "verb": "Capture scorecard",
      "tool": "Tally",
      "owner": "inbox-agent",
      "crm": "crm_capture_lead",
      "status": "built"
    },
    {
      "id": "1.14",
      "phase": "P1",
      "kind": "action",
      "verb": "Capture enquiry",
      "tool": "Web form",
      "owner": "inbox-agent",
      "crm": "crm_capture_lead",
      "status": "built"
    },
    {
      "id": "1.15",
      "phase": "P1",
      "kind": "action",
      "verb": "Track newsletter clicks",
      "tool": "Resend",
      "alternatives": [
        "Beehiiv"
      ],
      "owner": "inbox-agent",
      "crm": "crm_log_engagement",
      "when": "$.lead_sources.inbound ? (@.newsletter == true)",
      "status": "built"
    },
    {
      "id": "1.16",
      "phase": "P1",
      "kind": "action",
      "verb": "Scan sector posts",
      "tool": "Apify",
      "alternatives": [
        "Saved swipe file"
      ],
      "owner": "social-agent",
      "check": "platform terms (public post data)",
      "when": "$.social.networks[*]",
      "status": "tested"
    },
    {
      "id": "1.17",
      "phase": "P1",
      "kind": "action",
      "verb": "Rank winning posts",
      "tool": "Claude",
      "owner": "social-agent",
      "status": "tested"
    },
    {
      "id": "1.18",
      "phase": "P1",
      "kind": "action",
      "verb": "Update hook library",
      "tool": "Claude",
      "owner": "social-agent",
      "crm": "crm_upsert_social_pattern",
      "status": "tested"
    },
    {
      "id": "1.19",
      "phase": "P1",
      "kind": "action",
      "verb": "Plan content calendar",
      "tool": "Claude",
      "owner": "social-agent",
      "crm": "crm_set_content_audience",
      "status": "built"
    },
    {
      "id": "1.20",
      "phase": "P1",
      "kind": "action",
      "verb": "Draft social post",
      "tool": "Claude",
      "owner": "social-agent",
      "crm": "crm_submit_content",
      "next": "1.21",
      "status": "built"
    },
    {
      "id": "1.21",
      "phase": "P1",
      "kind": "action",
      "verb": "Approve post",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_decide_content",
      "next": "1.6",
      "status": "tested"
    },
    {
      "id": "1.22",
      "phase": "P1",
      "kind": "action",
      "verb": "Collect post metrics",
      "tool": "Meta insights",
      "alternatives": [
        "Buffer API"
      ],
      "owner": "social-agent",
      "crm": "crm_record_content_metrics",
      "status": "tested"
    },
    {
      "id": "1.23",
      "phase": "P1",
      "kind": "action",
      "verb": "Attribute leads to posts",
      "tool": "CRM",
      "owner": "social-agent",
      "crm": "crm_log_engagement",
      "status": "built"
    },
    {
      "id": "1.24",
      "phase": "P1",
      "kind": "action",
      "verb": "Learn what works",
      "tool": "Claude",
      "owner": "social-agent",
      "crm": "crm_upsert_social_pattern",
      "next": "1.18",
      "status": "built"
    },
    {
      "id": "1.25",
      "phase": "P1",
      "kind": "action",
      "verb": "Capture social DM lead",
      "tool": "ManyChat",
      "owner": "inbox-agent",
      "check": "Meta 24-hour messaging rule",
      "crm": "crm_capture_lead",
      "next": "6.R",
      "per_tenant": true,
      "when": "$.tools ? (@.manychat == true)",
      "status": "built"
    },
    {
      "id": "1.26",
      "phase": "P1",
      "kind": "action",
      "verb": "Plan ad campaign",
      "tool": "Claude",
      "owner": "content-agent",
      "crm": "crm_plan_ad_campaign",
      "when": "$.channels.ads ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.27",
      "phase": "P1",
      "kind": "action",
      "verb": "Create ad variants",
      "tool": "Claude",
      "owner": "content-agent",
      "crm": "crm_add_ad_variant",
      "next": "1.28",
      "when": "$.channels.ads ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.28",
      "phase": "P1",
      "kind": "action",
      "verb": "Approve ad and budget",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_decide_ad_campaign",
      "next": "1.29",
      "when": "$.channels.ads ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.29",
      "phase": "P1",
      "kind": "action",
      "verb": "Launch ads",
      "tool": "Meta Marketing API",
      "alternatives": [
        "Google Ads API",
        "Upload pack"
      ],
      "owner": "content-agent",
      "crm": "crm_mark_ad_live",
      "next": "1.30",
      "when": "$.channels.ads ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.30",
      "phase": "P1",
      "kind": "action",
      "verb": "Collect ad results",
      "tool": "Meta Marketing API",
      "alternatives": [
        "Google Ads API"
      ],
      "owner": "content-agent",
      "crm": "crm_record_ad_results",
      "next": "1.31",
      "when": "$.channels.ads ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.31",
      "phase": "P1",
      "kind": "action",
      "verb": "Adjust ads",
      "tool": "Claude",
      "owner": "content-agent",
      "crm": "crm_propose_ad_adjustment",
      "next": "1.26",
      "when": "$.channels.ads ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.32",
      "phase": "P1",
      "kind": "action",
      "verb": "Edit website",
      "tool": "Website studio",
      "alternatives": [
        "Claude"
      ],
      "owner": "content-agent",
      "next": "1.33",
      "status": "built"
    },
    {
      "id": "1.33",
      "phase": "P1",
      "kind": "action",
      "verb": "Publish website changes",
      "tool": "Website studio",
      "owner": "human",
      "human": true,
      "status": "built"
    },
    {
      "id": "1.34",
      "phase": "P1",
      "kind": "action",
      "verb": "Map search demand",
      "tool": "DataForSEO",
      "alternatives": [
        "Claude"
      ],
      "owner": "content-agent",
      "crm": "crm_register_document",
      "next": "1.2",
      "status": "built"
    },
    {
      "id": "1.35",
      "phase": "P1",
      "kind": "action",
      "verb": "Feature on the Ogma hub",
      "tool": "Cloudflare Pages",
      "owner": "content-agent",
      "crm": "crm_set_content_meta",
      "when": "$.content.hub ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.36",
      "phase": "P1",
      "kind": "action",
      "verb": "Refresh old articles",
      "tool": "Claude",
      "owner": "content-agent",
      "next": "1.3",
      "status": "tested"
    },
    {
      "id": "1.37",
      "phase": "P1",
      "kind": "action",
      "verb": "Check AI search visibility",
      "tool": "Claude",
      "alternatives": [
        "Otterly",
        "Peec AI"
      ],
      "owner": "content-agent",
      "crm": "crm_register_document",
      "status": "built"
    },
    {
      "id": "1.38",
      "phase": "P1",
      "kind": "action",
      "verb": "Script video",
      "tool": "Claude",
      "owner": "social-agent",
      "crm": "crm_plan_content",
      "when": "$.social.video ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "1.39",
      "phase": "P1",
      "kind": "action",
      "verb": "Record video",
      "tool": "Teleprompter",
      "owner": "social-agent",
      "next": "1.41",
      "when": "$.social.video ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.40",
      "phase": "P1",
      "kind": "action",
      "verb": "Generate video",
      "tool": "HeyGen",
      "alternatives": [
        "ElevenLabs",
        "Veo",
        "Shotstack"
      ],
      "owner": "social-agent",
      "check": "AI disclosure and consent",
      "next": "1.41",
      "when": "$.social.video ? (@.ai == true)",
      "status": "built"
    },
    {
      "id": "1.41",
      "phase": "P1",
      "kind": "action",
      "verb": "Clip into versions",
      "tool": "ffmpeg",
      "alternatives": [
        "OpusClip"
      ],
      "owner": "social-agent",
      "crm": "crm_attach_content_asset",
      "next": "1.21",
      "when": "$.social.video ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "1.42",
      "phase": "P1",
      "kind": "action",
      "verb": "Find niche listings",
      "tool": "Listings catalogue",
      "alternatives": [
        "Claude"
      ],
      "owner": "listings-agent",
      "when": "$.listings ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "1.43",
      "phase": "P1",
      "kind": "action",
      "verb": "Claim and update listings",
      "tool": "Google Business Profile API",
      "alternatives": [
        "BrightLocal",
        "Guided checklist"
      ],
      "owner": "listings-agent",
      "when": "$.listings ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.44",
      "phase": "P1",
      "kind": "action",
      "verb": "Check listing consistency",
      "tool": "Website crawler",
      "owner": "listings-agent",
      "when": "$.listings ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "1.45",
      "phase": "P1",
      "kind": "action",
      "verb": "Request reviews",
      "tool": "Email",
      "alternatives": [
        "SMS"
      ],
      "owner": "listings-agent",
      "check": "DMCC fake reviews rules",
      "when": "$.listings.reviews ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.46",
      "phase": "P1",
      "kind": "action",
      "verb": "Draft review replies",
      "tool": "Claude",
      "owner": "listings-agent",
      "crm": "crm_draft_review_reply",
      "next": "1.21",
      "when": "$.listings.reviews ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.47",
      "phase": "P1",
      "kind": "action",
      "verb": "Pitch for mentions",
      "tool": "Claude",
      "owner": "listings-agent",
      "next": "1.21",
      "when": "$.listings ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.48",
      "phase": "P1",
      "kind": "action",
      "verb": "Send results to ad platforms",
      "tool": "Meta Conversions API",
      "alternatives": [
        "Google Data Manager API",
        "Microsoft Ads"
      ],
      "owner": "content-agent",
      "check": "PECR consent",
      "crm": "crm_record_ad_conversion",
      "when": "$.channels.ads ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.49",
      "phase": "P1",
      "kind": "action",
      "verb": "Attach traceable CTA",
      "tool": "CTA library",
      "owner": "content-agent",
      "crm": "crm_attach_cta",
      "next": "1.21",
      "status": "built"
    },
    {
      "id": "1.50",
      "phase": "P1",
      "kind": "action",
      "verb": "Record CTA click",
      "tool": "Intake go link",
      "owner": "inbox-agent",
      "crm": "crm_record_cta_click",
      "status": "built"
    },
    {
      "id": "1.51",
      "phase": "P1",
      "kind": "action",
      "verb": "Hand lead to Connect",
      "tool": "CRM",
      "owner": "inbox-agent",
      "crm": "crm_attribute_cta",
      "next": "6.R",
      "status": "built"
    },
    {
      "id": "1.52",
      "phase": "P1",
      "kind": "action",
      "verb": "Keep content library",
      "tool": "CRM",
      "owner": "social-agent",
      "crm": "crm_upsert_segment",
      "when": "$.social.video ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.53",
      "phase": "P1",
      "kind": "action",
      "verb": "Remix new cut",
      "tool": "ffmpeg",
      "owner": "social-agent",
      "crm": "crm_plan_content",
      "next": "1.21",
      "when": "$.social.video ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.54",
      "phase": "P1",
      "kind": "action",
      "verb": "Test post variants",
      "tool": "CRM",
      "owner": "social-agent",
      "crm": "crm_mark_content_variant",
      "next": "1.21",
      "status": "built"
    },
    {
      "id": "1.55",
      "phase": "P1",
      "kind": "action",
      "verb": "Re-post evergreen pieces",
      "tool": "Claude",
      "owner": "social-agent",
      "crm": "crm_plan_content",
      "next": "1.21",
      "when": "$.social.evergreen ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.56",
      "phase": "P1",
      "kind": "action",
      "verb": "Prepare syndication packs",
      "tool": "Claude",
      "owner": "content-agent",
      "crm": "crm_queue_syndication_pack",
      "next": "1.21",
      "when": "$.lead_sources.inbound ? (@.newsletter == true)",
      "status": "built"
    },
    {
      "id": "1.57",
      "phase": "P1",
      "kind": "action",
      "verb": "Hand happy reviewers to Network",
      "tool": "CRM",
      "owner": "listings-agent",
      "crm": "crm_queue_referral_ask",
      "next": "10.3",
      "when": "$.listings.reviews ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.58",
      "phase": "P1",
      "kind": "action",
      "verb": "Make print pack",
      "tool": "Brand kit",
      "owner": "content-agent",
      "crm": "crm_submit_print_pack",
      "next": "1.59",
      "when": "$.attract.print ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "1.59",
      "phase": "P1",
      "kind": "action",
      "verb": "Approve print pack",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_decide_content",
      "next": "1.60",
      "when": "$.attract.print ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "1.60",
      "phase": "P1",
      "kind": "action",
      "verb": "Hand over the print pack",
      "tool": "Print-ready download",
      "owner": "content-agent",
      "crm": "crm_hand_over_print_pack",
      "when": "$.attract.print ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "1.61",
      "phase": "P1",
      "kind": "action",
      "verb": "Send an instant reply to an enquiry",
      "tool": "WhatsApp Cloud API",
      "alternatives": [
        "Gmail",
        "Microsoft 365",
        "Resend"
      ],
      "owner": "inbox-agent",
      "crm": "crm_instant_reply_prepare",
      "next": "6.R",
      "when": "$.speed_to_lead.instant_reply ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "1.62",
      "phase": "P1",
      "kind": "engine",
      "verb": "Read search performance",
      "tool": "Google Search Console",
      "owner": "content-agent",
      "crm": "crm_record_search_performance",
      "status": "built"
    },
    {
      "id": "1.63",
      "phase": "P1",
      "kind": "engine",
      "verb": "Score content brief",
      "tool": "DataForSEO",
      "owner": "content-agent",
      "crm": "crm_set_content_meta",
      "status": "tested"
    },
    {
      "id": "1.67",
      "phase": "P1",
      "kind": "engine",
      "verb": "Make picture",
      "tool": "Gemini image API",
      "owner": "content-agent",
      "crm": "crm_attach_content_asset",
      "status": "built"
    },
    {
      "id": "1.69",
      "phase": "P1",
      "kind": "action",
      "verb": "Prepare LinkedIn engage list",
      "tool": "Claude",
      "owner": "social-agent",
      "crm": "crm_create_task",
      "status": "built"
    },
    {
      "id": "1.70",
      "phase": "P1",
      "kind": "engine",
      "verb": "Welcome new subscriber",
      "tool": "Resend",
      "owner": "content-agent",
      "crm": "crm_queue_welcome",
      "status": "built"
    },
    {
      "id": "1.W",
      "phase": "P1",
      "kind": "crm_write",
      "verb": "Create inbound lead",
      "tool": "Edge Function",
      "owner": "inbox-agent",
      "crm": "crm_capture_lead",
      "next": "6.R",
      "status": "built"
    },
    {
      "id": "2.1",
      "phase": "P2",
      "kind": "action",
      "verb": "Pull register lists",
      "tool": "Register scraper",
      "owner": "sourcing-agent",
      "crm": "crm_record_signal",
      "status": "built"
    },
    {
      "id": "2.2",
      "phase": "P2",
      "kind": "action",
      "verb": "Pull company filings",
      "tool": "Companies House API",
      "owner": "sourcing-agent",
      "crm": "crm_find_organisation",
      "status": "built"
    },
    {
      "id": "2.3",
      "phase": "P2",
      "kind": "action",
      "verb": "Watch filing events",
      "tool": "Companies House API",
      "owner": "sourcing-agent",
      "crm": "crm_record_signal",
      "status": "built"
    },
    {
      "id": "2.4",
      "phase": "P2",
      "kind": "action",
      "verb": "Watch news and job posts",
      "tool": "News sweep",
      "owner": "sourcing-agent",
      "crm": "crm_record_signal",
      "status": "built"
    },
    {
      "id": "2.5",
      "phase": "P2",
      "kind": "action",
      "verb": "Monitor deal platforms",
      "tool": "Email alerts",
      "owner": "sourcing-agent",
      "crm": "crm_get_cursor",
      "next": "2.6",
      "when": "$.lead_sources.mailbox.deal_alerts ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "2.6",
      "phase": "P2",
      "kind": "action",
      "verb": "Parse broker teasers",
      "tool": "Claude",
      "owner": "inbox-agent",
      "crm": "crm_record_signal",
      "when": "$.lead_sources.mailbox ? (@.deal_alerts.enabled == true || @.teasers.enabled == true)",
      "status": "tested"
    },
    {
      "id": "2.7",
      "phase": "P2",
      "kind": "action",
      "verb": "Email referrers",
      "tool": "Gmail",
      "owner": "relationship-agent",
      "crm": "crm_unscheduled_referrers",
      "status": "built"
    },
    {
      "id": "2.8",
      "phase": "P2",
      "kind": "action",
      "verb": "Parse introduction",
      "tool": "Claude",
      "owner": "inbox-agent",
      "crm": "crm_record_referral",
      "status": "tested"
    },
    {
      "id": "2.9",
      "phase": "P2",
      "kind": "action",
      "verb": "Scan tender portals",
      "tool": "Find a Tender API",
      "owner": "sourcing-agent",
      "crm": "crm_record_signal",
      "per_tenant": true,
      "when": "$.lead_sources.business_specific.tenders ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "2.10",
      "phase": "P2",
      "kind": "action",
      "verb": "Watch RFP inbox",
      "tool": "Gmail",
      "owner": "inbox-agent",
      "crm": "crm_capture_lead",
      "per_tenant": true,
      "when": "$.lead_sources.business_specific.rfp_inbox ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "2.11",
      "phase": "P2",
      "kind": "action",
      "verb": "Run custom source",
      "tool": "Per-business plug-in",
      "owner": "sourcing-agent",
      "per_tenant": true,
      "when": "$.lead_sources.business_specific.custom[*]",
      "status": "built"
    },
    {
      "id": "2.13",
      "phase": "P2",
      "kind": "action",
      "verb": "Search map listings",
      "tool": "Google Places API",
      "owner": "sourcing-agent",
      "crm": "crm_record_source_hit",
      "when": "$.target.search_terms.*[*]",
      "status": "built"
    },
    {
      "id": "2.14",
      "phase": "P2",
      "kind": "action",
      "verb": "Collect directory listings",
      "tool": "Directory plug-in",
      "owner": "sourcing-agent",
      "crm": "crm_record_source_hit",
      "per_tenant": true,
      "when": "$.lead_sources.directories.*",
      "status": "built"
    },
    {
      "id": "2.15",
      "phase": "P2",
      "kind": "action",
      "verb": "Find social profiles",
      "tool": "Apify",
      "owner": "sourcing-agent",
      "check": "platform terms (public profiles)",
      "crm": "crm_record_source_hit",
      "when": "$.social.networks[*]",
      "status": "tested"
    },
    {
      "id": "2.16",
      "phase": "P2",
      "kind": "action",
      "verb": "Plan a prospect search",
      "tool": "Claude",
      "owner": "sourcing-agent",
      "crm": "crm_create_prospect_search",
      "status": "built"
    },
    {
      "id": "2.17",
      "phase": "P2",
      "kind": "crm_read",
      "verb": "Search the prospect database",
      "tool": "Ogma prospect database",
      "owner": "sourcing-agent",
      "crm": "crm_ref_search",
      "status": "built"
    },
    {
      "id": "2.18",
      "phase": "P2",
      "kind": "action",
      "verb": "Top up with a live search",
      "tool": "Google Places API",
      "alternatives": [
        "Claude web search",
        "Registers",
        "Directory plug-in"
      ],
      "owner": "sourcing-agent",
      "crm": "crm_set_prospect_results",
      "status": "todo"
    },
    {
      "id": "2.19",
      "phase": "P2",
      "kind": "action",
      "verb": "Run a prospect search (the Find firms press is its only approval)",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_decide_prospect_search",
      "status": "built"
    },
    {
      "id": "2.20",
      "phase": "P2",
      "kind": "action",
      "verb": "Review the prospect list",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_mark_prospects",
      "status": "built"
    },
    {
      "id": "2.21",
      "phase": "P2",
      "kind": "crm_write",
      "verb": "Copy picked firms to the CRM",
      "tool": "CRM",
      "owner": "sourcing-agent",
      "crm": "crm_pick_firms",
      "status": "built"
    },
    {
      "id": "2.22",
      "phase": "P2",
      "kind": "action",
      "verb": "Find relevant events",
      "tool": "Claude web search",
      "alternatives": [
        "Industry calendar",
        "Source register",
        "Inbox label"
      ],
      "owner": "relationship-agent",
      "crm": "crm_upsert_event",
      "next": "2.23",
      "when": "$.network.events ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "2.23",
      "phase": "P2",
      "kind": "action",
      "verb": "Score and shortlist events",
      "tool": "Claude",
      "owner": "relationship-agent",
      "crm": "crm_shortlist_events",
      "next": "2.24",
      "when": "$.network.events ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "2.24",
      "phase": "P2",
      "kind": "action",
      "verb": "Choose events to attend",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_decide_event",
      "when": "$.network.events ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "2.25",
      "phase": "P2",
      "kind": "action",
      "verb": "Pitch the organisers",
      "tool": "Gmail",
      "owner": "relationship-agent",
      "crm": "crm_record_event_pitch",
      "when": "$.network.events ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "2.26",
      "phase": "P2",
      "kind": "action",
      "verb": "Build the event meeting list",
      "tool": "Ogma prospect database",
      "owner": "sourcing-agent",
      "crm": "crm_add_event_meeting_targets",
      "next": "2.27",
      "when": "$.network.events ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "2.27",
      "phase": "P2",
      "kind": "action",
      "verb": "Book meetings before the event",
      "tool": "Gmail",
      "alternatives": [
        "Google Calendar"
      ],
      "owner": "scheduler-agent",
      "crm": "crm_record_event_message",
      "next": "7.R",
      "when": "$.network.events ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "2.28",
      "phase": "P2",
      "kind": "action",
      "verb": "Capture contacts at the event",
      "tool": "QR code",
      "alternatives": [
        "Business card photo",
        "Claude"
      ],
      "owner": "inbox-agent",
      "crm": "crm_capture_event_contact",
      "next": "2.29",
      "when": "$.network.events ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "2.29",
      "phase": "P2",
      "kind": "action",
      "verb": "Follow up after the event",
      "tool": "Gmail",
      "owner": "relationship-agent",
      "check": "GDPR Art. 14 notice (name the event)",
      "crm": "crm_record_event_message",
      "next": "6.2",
      "when": "$.network.events ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "2.30",
      "phase": "P2",
      "kind": "action",
      "verb": "Run offer workshop",
      "tool": "Claude",
      "owner": "strategy-agent",
      "crm": "crm_offer_workshop_set_card",
      "status": "built"
    },
    {
      "id": "2.31",
      "phase": "P2",
      "kind": "action",
      "verb": "Cold-test the offer",
      "tool": "Claude",
      "owner": "strategy-agent",
      "crm": "crm_offer_workshop_set_test",
      "next": "0.5",
      "status": "built"
    },
    {
      "id": "2.32",
      "phase": "P2",
      "kind": "action",
      "verb": "Confirm same firm",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_answer_same_firm",
      "status": "built"
    },
    {
      "id": "2.33",
      "phase": "P2",
      "kind": "action",
      "verb": "Plan the cadence",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_propose_cadence",
      "status": "built"
    },
    {
      "id": "2.34",
      "phase": "P2",
      "kind": "action",
      "verb": "Show first prospects and a sample email",
      "tool": "Ogma prospect database",
      "alternatives": [
        "Claude"
      ],
      "owner": "sourcing-agent",
      "crm": "crm_record_sample",
      "status": "built"
    },
    {
      "id": "2.35",
      "phase": "P2",
      "kind": "action",
      "verb": "Watch careers pages for roles you could replace",
      "tool": "Careers page reader",
      "alternatives": [
        "Reed"
      ],
      "owner": "sourcing-agent",
      "crm": "crm_record_job_posts",
      "status": "built"
    },
    {
      "id": "2.36",
      "phase": "P2",
      "kind": "action",
      "verb": "Spot new senior hires and team changes",
      "tool": "Companies House API",
      "alternatives": [
        "Website crawl"
      ],
      "owner": "sourcing-agent",
      "crm": "crm_record_team_changes",
      "status": "built"
    },
    {
      "id": "2.37",
      "phase": "P2",
      "kind": "action",
      "verb": "Hold a firm for manual outreach only",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_set_outreach_mode",
      "status": "built"
    },
    {
      "id": "2.38",
      "phase": "P2",
      "kind": "engine",
      "verb": "Rank a campaign's prospects by fit and interest with the best contact",
      "tool": "Jev (TypeSafe)",
      "alternatives": [
        "Claude"
      ],
      "owner": "ops-agent",
      "crm": "crm_rank_prospect_results",
      "status": "built"
    },
    {
      "id": "2.39",
      "phase": "P2",
      "kind": "action",
      "verb": "Warn when a search's best matches run low",
      "tool": "Rules",
      "owner": "sourcing-agent",
      "crm": "crm_raise_search_prompt",
      "status": "tested"
    },
    {
      "id": "2.40",
      "phase": "P2",
      "kind": "crm_read",
      "verb": "Build today's list",
      "tool": "CRM",
      "owner": "outreach-agent",
      "crm": "crm_find_today",
      "status": "built"
    },
    {
      "id": "2.41",
      "phase": "P2",
      "kind": "engine",
      "verb": "Act on a signal",
      "tool": "Claude",
      "owner": "sourcing-agent",
      "crm": "crm_signal_enrol",
      "status": "tested"
    },
    {
      "id": "2.42",
      "phase": "P2",
      "kind": "crm_read",
      "verb": "Score signal heat",
      "tool": "CRM",
      "owner": "sourcing-agent",
      "crm": "crm_signal_heat",
      "status": "tested"
    },
    {
      "id": "2.43",
      "phase": "P2",
      "kind": "engine",
      "verb": "Give ranked firms reasons from their signals",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_signal_packs, crm_apply_prospect_reasons",
      "status": "built"
    },
    {
      "id": "2.44",
      "phase": "P2",
      "kind": "crm_read",
      "verb": "Browse events, networks and partners",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_network_events, crm_network_bodies, crm_network_partners, crm_network_save",
      "status": "built"
    },
    {
      "id": "2.45",
      "phase": "P2",
      "kind": "engine",
      "verb": "Label partners as complement or competitor",
      "tool": "Claude",
      "owner": "relationship-agent",
      "crm": "crm_network_set_relationship",
      "status": "built"
    },
    {
      "id": "2.12",
      "phase": "P2",
      "kind": "action",
      "verb": "Tag to segments",
      "tool": "Claude",
      "owner": "sourcing-agent",
      "crm": "crm_set_segments",
      "status": "built"
    },
    {
      "id": "2.R",
      "phase": "P2",
      "kind": "crm_read",
      "verb": "Check suppression list",
      "tool": "Claude CRM connector",
      "owner": "sourcing-agent",
      "crm": "crm_is_organisation_suppressed",
      "status": "built"
    },
    {
      "id": "2.W",
      "phase": "P2",
      "kind": "crm_write",
      "verb": "Create or update lead",
      "tool": "Claude CRM connector",
      "owner": "sourcing-agent",
      "crm": "crm_upsert_organisation",
      "status": "built"
    },
    {
      "id": "3.R",
      "phase": "P3",
      "kind": "crm_read",
      "verb": "Read new leads",
      "tool": "CRM",
      "owner": "enrichment-agent",
      "crm": "crm_enrichment_queue",
      "status": "built"
    },
    {
      "id": "3.9",
      "phase": "P3",
      "kind": "action",
      "verb": "Crawl website",
      "tool": "Website crawler",
      "owner": "enrichment-agent",
      "next": "3.1",
      "status": "built"
    },
    {
      "id": "3.1",
      "phase": "P3",
      "kind": "action",
      "verb": "Find owner",
      "tool": "Companies House API",
      "alternatives": [
        "Website crawler"
      ],
      "owner": "enrichment-agent",
      "crm": "crm_upsert_person",
      "status": "built"
    },
    {
      "id": "3.2",
      "phase": "P3",
      "kind": "action",
      "verb": "Find second contact",
      "tool": "Companies House API",
      "alternatives": [
        "Website crawler"
      ],
      "owner": "enrichment-agent",
      "crm": "crm_upsert_person",
      "status": "built"
    },
    {
      "id": "3.3",
      "phase": "P3",
      "kind": "action",
      "verb": "Find email",
      "tool": "Own database then pattern guesses",
      "alternatives": [
        "Hunter"
      ],
      "owner": "enrichment-agent",
      "crm": "crm_lookup_email",
      "status": "built"
    },
    {
      "id": "3.4",
      "phase": "P3",
      "kind": "action",
      "verb": "Verify email",
      "tool": "MillionVerifier",
      "owner": "enrichment-agent",
      "crm": "crm_record_email_check",
      "status": "built"
    },
    {
      "id": "3.5",
      "phase": "P3",
      "kind": "action",
      "verb": "Find phone and LinkedIn",
      "tool": "Company website",
      "alternatives": [
        "Apollo"
      ],
      "owner": "enrichment-agent",
      "check": "GDPR notice",
      "status": "built"
    },
    {
      "id": "3.6",
      "phase": "P3",
      "kind": "action",
      "verb": "Research account",
      "tool": "Claude",
      "owner": "enrichment-agent",
      "crm": "crm_set_account_research",
      "status": "built"
    },
    {
      "id": "3.7",
      "phase": "P3",
      "kind": "action",
      "verb": "Write personal hook",
      "tool": "Claude",
      "owner": "enrichment-agent",
      "crm": "crm_set_person_hook",
      "status": "built"
    },
    {
      "id": "3.8",
      "phase": "P3",
      "kind": "action",
      "verb": "Score fit and intent",
      "tool": "Claude",
      "owner": "enrichment-agent",
      "crm": "crm_set_scores",
      "status": "built"
    },
    {
      "id": "3.10",
      "phase": "P3",
      "kind": "action",
      "verb": "Tag contact purpose",
      "tool": "CRM screens",
      "alternatives": [
        "Claude"
      ],
      "owner": "enrichment-agent",
      "crm": "crm_set_person_tags",
      "status": "tested"
    },
    {
      "id": "3.11",
      "phase": "P3",
      "kind": "action",
      "verb": "Record how we connected",
      "tool": "CRM screens",
      "alternatives": [
        "Claude"
      ],
      "owner": "enrichment-agent",
      "crm": "crm_link_people",
      "status": "tested"
    },
    {
      "id": "3.12",
      "phase": "P3",
      "kind": "crm_read",
      "verb": "List and save views",
      "tool": "CRM",
      "owner": "supervisor",
      "crm": "crm_list_records",
      "status": "tested"
    },
    {
      "id": "3.13",
      "phase": "P3",
      "kind": "crm_write",
      "verb": "Bulk update records",
      "tool": "CRM",
      "owner": "supervisor",
      "crm": "crm_bulk_update_organisations",
      "status": "tested"
    },
    {
      "id": "3.14",
      "phase": "P3",
      "kind": "engine",
      "verb": "Score connection strength",
      "tool": "CRM",
      "owner": "inbox-agent",
      "crm": "crm_recompute_strength",
      "status": "built"
    },
    {
      "id": "3.15",
      "phase": "P3",
      "kind": "engine",
      "verb": "Find duplicates",
      "tool": "CRM",
      "owner": "enrichment-agent",
      "crm": "crm_find_duplicates",
      "status": "built"
    },
    {
      "id": "3.16",
      "phase": "P3",
      "kind": "action",
      "verb": "Merge duplicates",
      "tool": "CRM",
      "owner": "human",
      "human": true,
      "crm": "crm_merge_organisations",
      "status": "built"
    },
    {
      "id": "3.17",
      "phase": "P3",
      "kind": "crm_write",
      "verb": "Log a call or note",
      "tool": "CRM",
      "owner": "supervisor",
      "crm": "crm_log_call",
      "status": "tested"
    },
    {
      "id": "3.18",
      "phase": "P3",
      "kind": "crm_write",
      "verb": "Keep owner tasks",
      "tool": "CRM",
      "owner": "supervisor",
      "crm": "crm_add_owner_task",
      "status": "tested"
    },
    {
      "id": "3.19",
      "phase": "P3",
      "kind": "action",
      "verb": "Prepare a brief on request",
      "tool": "Claude",
      "owner": "deal-agent",
      "crm": "crm_request_brief",
      "status": "built"
    },
    {
      "id": "3.20",
      "phase": "P3",
      "kind": "action",
      "verb": "Write a firm brief from its website",
      "tool": "Claude",
      "owner": "enrichment-agent",
      "crm": "crm_record_firm_brief",
      "status": "built"
    },
    {
      "id": "3.21",
      "phase": "P3",
      "kind": "action",
      "verb": "Pick the person to write to",
      "tool": "Claude",
      "owner": "enrichment-agent",
      "crm": "crm_firm_known_people",
      "status": "built"
    },
    {
      "id": "3.22",
      "phase": "P3",
      "kind": "engine",
      "verb": "Keep the firm's dossier",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_keep_dossiers",
      "status": "built"
    },
    {
      "id": "3.W",
      "phase": "P3",
      "kind": "crm_write",
      "verb": "Write contacts and score",
      "tool": "CRM",
      "owner": "enrichment-agent",
      "crm": "crm_mark_enriched",
      "status": "built"
    },
    {
      "id": "4.R",
      "phase": "P4",
      "kind": "crm_read",
      "verb": "Read due touches",
      "tool": "CRM",
      "owner": "outreach-agent",
      "crm": "crm_due_touches",
      "status": "tested"
    },
    {
      "id": "4.1",
      "phase": "P4",
      "kind": "action",
      "verb": "Pick channel mix",
      "tool": "Claude",
      "owner": "outreach-agent",
      "crm": "crm_allowed_channels",
      "status": "built"
    },
    {
      "id": "4.2",
      "phase": "P4",
      "kind": "action",
      "verb": "Write channel copy",
      "tool": "Claude",
      "owner": "outreach-agent",
      "crm": "crm_queue_draft",
      "next": "4.10",
      "status": "tested"
    },
    {
      "id": "4.3",
      "phase": "P4",
      "kind": "action",
      "verb": "Send email",
      "tool": "Gmail API",
      "alternatives": [
        "Instantly"
      ],
      "owner": "outreach-agent",
      "crm": "crm_next_outbox",
      "when": "$.channels.email ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "4.4",
      "phase": "P4",
      "kind": "action",
      "verb": "Send letter",
      "tool": "Scribeless",
      "owner": "outreach-agent",
      "crm": "crm_next_outbox",
      "when": "$.channels.letter ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "4.5",
      "phase": "P4",
      "kind": "action",
      "verb": "Send LinkedIn message",
      "tool": "HeyReach",
      "owner": "outreach-agent",
      "check": "LinkedIn terms",
      "when": "$.channels.linkedin ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "4.6",
      "phase": "P4",
      "kind": "action",
      "verb": "Send personal video",
      "tool": "HeyGen",
      "owner": "outreach-agent",
      "when": "$.channels.video ? (@.enabled == true)",
      "status": "todo"
    },
    {
      "id": "4.7",
      "phase": "P4",
      "kind": "action",
      "verb": "Place AI call",
      "tool": "Vapi",
      "owner": "outreach-agent",
      "check": "PECR consent",
      "when": "$.channels.call ? (@.enabled == true && @.mode == \"ai\")",
      "status": "todo"
    },
    {
      "id": "4.8",
      "phase": "P4",
      "kind": "action",
      "verb": "Show retargeting ad",
      "tool": "Meta Ads",
      "alternatives": [
        "Google Ads",
        "LinkedIn Ads"
      ],
      "owner": "outreach-agent",
      "when": "$.channels.ads ? (@.enabled == true)",
      "status": "todo"
    },
    {
      "id": "4.9",
      "phase": "P4",
      "kind": "action",
      "verb": "Send WhatsApp follow-up",
      "tool": "WhatsApp Cloud API",
      "owner": "outreach-agent",
      "check": "opt-in only",
      "crm": "crm_queue_whatsapp",
      "when": "$.channels.whatsapp ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "4.10",
      "phase": "P4",
      "kind": "action",
      "verb": "Approve message batch",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_decide_drafts",
      "status": "tested"
    },
    {
      "id": "4.11",
      "phase": "P4",
      "kind": "action",
      "verb": "Draft campaign",
      "tool": "Claude",
      "owner": "outreach-agent",
      "crm": "crm_create_campaign",
      "next": "4.10",
      "status": "tested"
    },
    {
      "id": "4.12",
      "phase": "P4",
      "kind": "action",
      "verb": "Act on a list",
      "tool": "CRM screens (Ask)",
      "owner": "human",
      "crm": "crm_run_bulk_action",
      "status": "tested"
    },
    {
      "id": "4.13",
      "phase": "P4",
      "kind": "action",
      "verb": "Prepare call list and briefs",
      "tool": "Claude",
      "owner": "outreach-agent",
      "crm": "crm_plan_call",
      "status": "built"
    },
    {
      "id": "4.14",
      "phase": "P4",
      "kind": "action",
      "verb": "Make a call",
      "tool": "Twilio",
      "alternatives": [
        "Phone"
      ],
      "owner": "human",
      "human": true,
      "crm": "crm_start_call",
      "status": "built"
    },
    {
      "id": "4.15",
      "phase": "P4",
      "kind": "action",
      "verb": "Log call outcome",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_log_call_outcome",
      "status": "built"
    },
    {
      "id": "4.16",
      "phase": "P4",
      "kind": "action",
      "verb": "Choose an asset for the touch",
      "tool": "Claude",
      "owner": "outreach-agent",
      "crm": "crm_outreach_asset_plan",
      "when": "$.outreach.assets ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "4.17",
      "phase": "P4",
      "kind": "action",
      "verb": "Build a personal asset",
      "tool": "Site builder",
      "alternatives": [
        "Claude"
      ],
      "owner": "content-agent",
      "check": "legal check before the first send",
      "crm": "crm_save_outreach_asset",
      "next": "4.2",
      "when": "$.outreach.assets ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "4.18",
      "phase": "P4",
      "kind": "action",
      "verb": "Publish the asset at its own address",
      "tool": "Cloudflare Worker",
      "owner": "ops-agent",
      "crm": "crm_publish_outreach_asset",
      "when": "$.outreach.assets ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "4.19",
      "phase": "P4",
      "kind": "action",
      "verb": "Claim an asset",
      "tool": "Asset page",
      "owner": "deal-agent",
      "crm": "crm_claim_outreach_asset",
      "when": "$.outreach.assets ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "4.20",
      "phase": "P4",
      "kind": "action",
      "verb": "Remove an asset on request",
      "tool": "Asset page",
      "owner": "inbox-agent",
      "crm": "crm_remove_outreach_asset",
      "when": "$.outreach.assets ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "4.21",
      "phase": "P4",
      "kind": "action",
      "verb": "Test send times",
      "tool": "Rules",
      "owner": "outreach-agent",
      "crm": "crm_send_time_results",
      "status": "built"
    },
    {
      "id": "4.22",
      "phase": "P4",
      "kind": "action",
      "verb": "Draft a message to send by hand",
      "tool": "Claude",
      "owner": "outreach-agent",
      "crm": "crm_queue_hand_send",
      "status": "tested"
    },
    {
      "id": "4.23",
      "phase": "P4",
      "kind": "action",
      "verb": "Mark a hand-sent message as sent",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_hand_send_sent",
      "status": "tested"
    },
    {
      "id": "4.24",
      "phase": "P4",
      "kind": "engine",
      "verb": "Score draft",
      "tool": "Code",
      "owner": "outreach-agent",
      "crm": "crm_queue_message",
      "status": "tested"
    },
    {
      "id": "4.25",
      "phase": "P4",
      "kind": "action",
      "verb": "Revise draft on request",
      "tool": "Claude",
      "owner": "outreach-agent",
      "crm": "crm_revise_draft",
      "status": "tested"
    },
    {
      "id": "4.26",
      "phase": "P4",
      "kind": "engine",
      "verb": "Choose letter address",
      "tool": "CRM",
      "owner": "outreach-agent",
      "crm": "crm_letter_address_choice",
      "status": "tested"
    },
    {
      "id": "4.W",
      "phase": "P4",
      "kind": "crm_write",
      "verb": "Log touch",
      "tool": "CRM",
      "owner": "outreach-agent",
      "crm": "crm_mark_outbox_sent",
      "status": "built"
    },
    {
      "id": "5.1",
      "phase": "P5",
      "kind": "action",
      "verb": "Catch email reply",
      "tool": "Gmail API",
      "alternatives": [
        "Instantly"
      ],
      "owner": "inbox-agent",
      "status": "tested"
    },
    {
      "id": "5.2",
      "phase": "P5",
      "kind": "action",
      "verb": "Catch LinkedIn reply",
      "tool": "HeyReach",
      "owner": "inbox-agent",
      "when": "$.channels.linkedin ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "5.3",
      "phase": "P5",
      "kind": "action",
      "verb": "Catch WhatsApp message",
      "tool": "WhatsApp Cloud API",
      "owner": "inbox-agent",
      "when": "$.channels.whatsapp ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "5.4",
      "phase": "P5",
      "kind": "action",
      "verb": "Transcribe call",
      "tool": "Vapi",
      "owner": "inbox-agent",
      "when": "$.channels.call ? (@.enabled == true && @.mode == \"ai\")",
      "status": "todo"
    },
    {
      "id": "5.5",
      "phase": "P5",
      "kind": "action",
      "verb": "Catch QR scan",
      "tool": "QR landing page",
      "owner": "inbox-agent",
      "status": "built"
    },
    {
      "id": "5.6",
      "phase": "P5",
      "kind": "action",
      "verb": "Track opens and clicks",
      "tool": "Instantly",
      "owner": "inbox-agent",
      "status": "built"
    },
    {
      "id": "5.7",
      "phase": "P5",
      "kind": "action",
      "verb": "Catch site revisit",
      "tool": "Intake visits",
      "alternatives": [
        "Dealfront"
      ],
      "owner": "inbox-agent",
      "crm": "crm_site_revisits",
      "status": "built"
    },
    {
      "id": "5.R",
      "phase": "P5",
      "kind": "crm_read",
      "verb": "Match identity",
      "tool": "n8n",
      "owner": "inbox-agent",
      "crm": "crm_match_identity",
      "status": "tested"
    },
    {
      "id": "5.8",
      "phase": "P5",
      "kind": "action",
      "verb": "Rescore lead",
      "tool": "Rules",
      "alternatives": [
        "Claude"
      ],
      "owner": "inbox-agent",
      "crm": "crm_rescore",
      "status": "built"
    },
    {
      "id": "5.9",
      "phase": "P5",
      "kind": "action",
      "verb": "Record WhatsApp opt-in",
      "tool": "CRM",
      "owner": "inbox-agent",
      "check": "PECR consent",
      "crm": "crm_record_whatsapp_consent",
      "when": "$.channels.whatsapp ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "5.10",
      "phase": "P5",
      "kind": "action",
      "verb": "Read 'has left' replies and bounces",
      "tool": "Rules",
      "owner": "inbox-agent",
      "crm": "crm_mark_moved",
      "status": "built"
    },
    {
      "id": "5.11",
      "phase": "P5",
      "kind": "action",
      "verb": "Catch a real view of an asset",
      "tool": "Asset page",
      "owner": "inbox-agent",
      "crm": "crm_record_asset_view",
      "when": "$.outreach.assets ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "5.12",
      "phase": "P5",
      "kind": "action",
      "verb": "Match replies to messages sent by hand",
      "tool": "Rules",
      "owner": "inbox-agent",
      "crm": "crm_match_hand_send",
      "status": "tested"
    },
    {
      "id": "5.13",
      "phase": "P5",
      "kind": "engine",
      "verb": "Record inbound call",
      "tool": "Twilio",
      "owner": "inbox-agent",
      "crm": "crm_record_inbound_call",
      "status": "built"
    },
    {
      "id": "5.W",
      "phase": "P5",
      "kind": "crm_write",
      "verb": "Log message and score",
      "tool": "n8n",
      "owner": "inbox-agent",
      "crm": "crm_log_message",
      "status": "tested"
    },
    {
      "id": "6.R",
      "phase": "P6",
      "kind": "crm_read",
      "verb": "Read conversation history",
      "tool": "Claude CRM connector",
      "owner": "inbox-agent",
      "status": "tested"
    },
    {
      "id": "6.1",
      "phase": "P6",
      "kind": "action",
      "verb": "Pause sequence",
      "tool": "CRM",
      "alternatives": [
        "Instantly"
      ],
      "owner": "inbox-agent",
      "status": "tested"
    },
    {
      "id": "6.2",
      "phase": "P6",
      "kind": "action",
      "verb": "Classify intent",
      "tool": "Claude",
      "owner": "inbox-agent",
      "crm": "crm_classify_message",
      "status": "tested"
    },
    {
      "id": "6.D",
      "phase": "P6",
      "kind": "decision",
      "verb": "Intent?",
      "options": [
        "interested",
        "question",
        "later",
        "no",
        "unsubscribe",
        "wrong_person",
        "unsure"
      ],
      "status": "tested"
    },
    {
      "id": "6.3",
      "phase": "P6",
      "kind": "action",
      "verb": "Draft reply",
      "tool": "Claude",
      "owner": "inbox-agent",
      "crm": "crm_connect_playbook",
      "status": "built"
    },
    {
      "id": "6.4",
      "phase": "P6",
      "kind": "action",
      "verb": "Send reply",
      "tool": "Gmail",
      "owner": "inbox-agent",
      "next": "7.R",
      "status": "tested"
    },
    {
      "id": "6.5",
      "phase": "P6",
      "kind": "action",
      "verb": "Answer objection",
      "tool": "Claude",
      "owner": "inbox-agent",
      "status": "tested"
    },
    {
      "id": "6.6",
      "phase": "P6",
      "kind": "action",
      "verb": "Send answer",
      "tool": "Gmail",
      "owner": "inbox-agent",
      "status": "tested"
    },
    {
      "id": "6.7",
      "phase": "P6",
      "kind": "action",
      "verb": "Ask for referral",
      "tool": "Gmail",
      "owner": "relationship-agent",
      "status": "built"
    },
    {
      "id": "6.8",
      "phase": "P6",
      "kind": "action",
      "verb": "Suppress everywhere",
      "tool": "n8n",
      "owner": "inbox-agent",
      "crm": "crm_suppress",
      "status": "built"
    },
    {
      "id": "6.9",
      "phase": "P6",
      "kind": "action",
      "verb": "Request right contact",
      "tool": "Gmail",
      "owner": "inbox-agent",
      "status": "built"
    },
    {
      "id": "6.10",
      "phase": "P6",
      "kind": "action",
      "verb": "Flag for review",
      "tool": "Gmail",
      "owner": "inbox-agent",
      "crm": "crm_answer_message",
      "status": "tested"
    },
    {
      "id": "6.11",
      "phase": "P6",
      "kind": "action",
      "verb": "Decide reply",
      "tool": "Gmail",
      "owner": "human",
      "human": true,
      "crm": "crm_decide_reply",
      "status": "tested"
    },
    {
      "id": "6.12",
      "phase": "P6",
      "kind": "action",
      "verb": "Tell the owner",
      "tool": "Gmail",
      "alternatives": [
        "Webhook",
        "WhatsApp"
      ],
      "owner": "inbox-agent",
      "crm": "crm_claim_hot_replies",
      "status": "built"
    },
    {
      "id": "6.13",
      "phase": "P6",
      "kind": "action",
      "verb": "Reply on WhatsApp",
      "tool": "WhatsApp Cloud API",
      "owner": "inbox-agent",
      "check": "Meta 24-hour window",
      "crm": "crm_submit_whatsapp_reply",
      "when": "$.channels.whatsapp ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "6.16",
      "phase": "P6",
      "kind": "crm_write",
      "verb": "Keep conversation state",
      "tool": "CRM",
      "owner": "inbox-agent",
      "crm": "crm_snooze_conversation",
      "status": "tested"
    },
    {
      "id": "6.17",
      "phase": "P6",
      "kind": "action",
      "verb": "Send reply from conversation",
      "tool": "CRM",
      "owner": "human",
      "human": true,
      "crm": "crm_send_conversation_reply",
      "status": "tested"
    },
    {
      "id": "6.18",
      "phase": "P6",
      "kind": "action",
      "verb": "Text back a missed call",
      "tool": "Twilio",
      "owner": "inbox-agent",
      "crm": "crm_record_inbound_call",
      "status": "built"
    },
    {
      "id": "6.W",
      "phase": "P6",
      "kind": "crm_write",
      "verb": "Update stage",
      "tool": "Claude CRM connector",
      "owner": "inbox-agent",
      "crm": "crm_set_stage",
      "status": "tested"
    },
    {
      "id": "7.R",
      "phase": "P7",
      "kind": "crm_read",
      "verb": "Read timezone",
      "tool": "Claude CRM connector",
      "owner": "scheduler-agent",
      "status": "built"
    },
    {
      "id": "7.1",
      "phase": "P7",
      "kind": "action",
      "verb": "Check availability",
      "tool": "Google Calendar",
      "owner": "scheduler-agent",
      "status": "built"
    },
    {
      "id": "7.2",
      "phase": "P7",
      "kind": "action",
      "verb": "Propose two slots",
      "tool": "Gmail",
      "owner": "scheduler-agent",
      "status": "tested"
    },
    {
      "id": "7.3",
      "phase": "P7",
      "kind": "action",
      "verb": "Parse acceptance",
      "tool": "Claude",
      "owner": "scheduler-agent",
      "status": "tested"
    },
    {
      "id": "7.4",
      "phase": "P7",
      "kind": "action",
      "verb": "Create event",
      "tool": "Google Calendar",
      "owner": "scheduler-agent",
      "status": "built"
    },
    {
      "id": "7.5",
      "phase": "P7",
      "kind": "action",
      "verb": "Send pre-read",
      "tool": "Gmail",
      "owner": "scheduler-agent",
      "status": "built"
    },
    {
      "id": "7.6",
      "phase": "P7",
      "kind": "action",
      "verb": "Send reminder",
      "tool": "Gmail",
      "owner": "scheduler-agent",
      "status": "built"
    },
    {
      "id": "7.7",
      "phase": "P7",
      "kind": "action",
      "verb": "Remind on WhatsApp",
      "tool": "WhatsApp Cloud API",
      "owner": "scheduler-agent",
      "check": "opt-in only",
      "crm": "crm_queue_whatsapp",
      "when": "$.channels.whatsapp ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "7.W",
      "phase": "P7",
      "kind": "crm_write",
      "verb": "Mark meeting booked",
      "tool": "n8n",
      "owner": "scheduler-agent",
      "crm": "crm_record_meeting",
      "status": "tested"
    },
    {
      "id": "7.8",
      "phase": "P7",
      "kind": "action",
      "verb": "Offer slots after an enquiry",
      "tool": "Intake",
      "owner": "inbox-agent",
      "crm": "crm_booking_offer",
      "next": "7.9",
      "when": "$.connect.booking ? (@.page == true)",
      "status": "built"
    },
    {
      "id": "7.9",
      "phase": "P7",
      "kind": "action",
      "verb": "Book on the booking page",
      "tool": "Ogma booking page",
      "alternatives": [
        "Google Calendar",
        "Zoom"
      ],
      "owner": "scheduler-agent",
      "crm": "crm_book_from_page",
      "next": "7.W",
      "when": "$.connect.booking ? (@.page == true)",
      "status": "built"
    },
    {
      "id": "7.10",
      "phase": "P7",
      "kind": "action",
      "verb": "Remind by text",
      "tool": "Twilio",
      "owner": "scheduler-agent",
      "check": "opt-in only",
      "crm": "crm_sms_reminder_prepare",
      "when": "$.connect.booking ? (@.sms_reminders == true)",
      "status": "built"
    },
    {
      "id": "7.11",
      "phase": "P7",
      "kind": "action",
      "verb": "Read in Calendly or Cal.com bookings",
      "tool": "Calendly",
      "alternatives": [
        "Cal.com"
      ],
      "owner": "inbox-agent",
      "crm": "crm_record_external_booking",
      "when": "$.connect.booking ? (@.calendly == true || @.cal_com == true)",
      "status": "built"
    },
    {
      "id": "7.12",
      "phase": "P7",
      "kind": "action",
      "verb": "Reschedule or cancel",
      "tool": "Google Calendar",
      "alternatives": [
        "Outlook calendar",
        "Zoom"
      ],
      "owner": "scheduler-agent",
      "crm": "crm_change_meeting",
      "status": "built"
    },
    {
      "id": "8.R",
      "phase": "P8",
      "kind": "crm_read",
      "verb": "Read full record",
      "tool": "Claude CRM connector",
      "owner": "deal-agent",
      "status": "built"
    },
    {
      "id": "8.1",
      "phase": "P8",
      "kind": "action",
      "verb": "Compile brief",
      "tool": "Claude",
      "owner": "deal-agent",
      "status": "tested"
    },
    {
      "id": "8.D",
      "phase": "P8",
      "kind": "decision",
      "verb": "Showed up?",
      "options": [
        "yes",
        "no"
      ],
      "status": "tested"
    },
    {
      "id": "8.2",
      "phase": "P8",
      "kind": "action",
      "verb": "Rebook no-show",
      "tool": "Gmail",
      "owner": "scheduler-agent",
      "next": "7.2",
      "status": "tested"
    },
    {
      "id": "8.3",
      "phase": "P8",
      "kind": "action",
      "verb": "Hold meeting",
      "tool": "Google Meet",
      "owner": "human",
      "human": true,
      "status": "built"
    },
    {
      "id": "8.4",
      "phase": "P8",
      "kind": "action",
      "verb": "Transcribe meeting",
      "tool": "Wispr Flow",
      "owner": "deal-agent",
      "status": "tested"
    },
    {
      "id": "8.5",
      "phase": "P8",
      "kind": "action",
      "verb": "Extract next steps",
      "tool": "Claude",
      "owner": "deal-agent",
      "status": "tested"
    },
    {
      "id": "8.6",
      "phase": "P8",
      "kind": "engine",
      "verb": "Extract meeting notes",
      "tool": "Claude",
      "owner": "deal-agent",
      "crm": "crm_record_meeting_notes",
      "status": "tested"
    },
    {
      "id": "8.7",
      "phase": "P8",
      "kind": "action",
      "verb": "Draft recap and quote answers from notes",
      "tool": "Claude",
      "owner": "deal-agent",
      "crm": "crm_record_meeting_notes",
      "status": "tested"
    },
    {
      "id": "8.8",
      "phase": "P8",
      "kind": "engine",
      "verb": "Send notetaker to meeting",
      "tool": "Recall.ai",
      "alternatives": [
        "Fathom",
        "Fireflies"
      ],
      "owner": "scheduler-agent",
      "check": "recording consent and DPIA before any client other than the first business",
      "crm": "register_transcript_source",
      "status": "tested"
    },
    {
      "id": "8.W",
      "phase": "P8",
      "kind": "crm_write",
      "verb": "Write notes and next step",
      "tool": "Claude CRM connector",
      "owner": "deal-agent",
      "crm": "crm_record_meeting",
      "status": "tested"
    },
    {
      "id": "9.R",
      "phase": "P9",
      "kind": "crm_read",
      "verb": "Read agreed next step",
      "tool": "Claude CRM connector",
      "owner": "deal-agent",
      "status": "built"
    },
    {
      "id": "9.1",
      "phase": "P9",
      "kind": "action",
      "verb": "Send recap",
      "tool": "Gmail",
      "owner": "deal-agent",
      "status": "tested"
    },
    {
      "id": "9.2",
      "phase": "P9",
      "kind": "action",
      "verb": "Send NDA or proposal",
      "tool": "Documenso",
      "alternatives": [
        "DocuSign"
      ],
      "owner": "deal-agent",
      "status": "tested"
    },
    {
      "id": "9.3",
      "phase": "P9",
      "kind": "action",
      "verb": "Collect information",
      "tool": "Google Drive",
      "owner": "deal-agent",
      "status": "built"
    },
    {
      "id": "9.4",
      "phase": "P9",
      "kind": "action",
      "verb": "Analyse information",
      "tool": "Claude",
      "owner": "deal-agent",
      "status": "tested"
    },
    {
      "id": "9.5",
      "phase": "P9",
      "kind": "action",
      "verb": "Draft offer",
      "tool": "Claude",
      "owner": "deal-agent",
      "status": "tested"
    },
    {
      "id": "9.6",
      "phase": "P9",
      "kind": "action",
      "verb": "Approve offer",
      "tool": "Documenso",
      "owner": "human",
      "human": true,
      "status": "built"
    },
    {
      "id": "9.7",
      "phase": "P9",
      "kind": "action",
      "verb": "Send offer",
      "tool": "Documenso",
      "alternatives": [
        "DocuSign"
      ],
      "owner": "deal-agent",
      "status": "built"
    },
    {
      "id": "9.D",
      "phase": "P9",
      "kind": "decision",
      "verb": "Decision?",
      "options": [
        "won",
        "no_answer",
        "objection",
        "lost"
      ],
      "status": "tested"
    },
    {
      "id": "9.8",
      "phase": "P9",
      "kind": "action",
      "verb": "Chase for decision",
      "tool": "Gmail",
      "owner": "deal-agent",
      "status": "built"
    },
    {
      "id": "9.9",
      "phase": "P9",
      "kind": "action",
      "verb": "Handle objection",
      "tool": "Claude",
      "owner": "deal-agent",
      "next": "9.7",
      "status": "tested"
    },
    {
      "id": "9.10",
      "phase": "P9",
      "kind": "action",
      "verb": "Record loss reason",
      "tool": "Claude",
      "owner": "deal-agent",
      "crm": "crm_close_lost",
      "status": "tested"
    },
    {
      "id": "9.11",
      "phase": "P9",
      "kind": "action",
      "verb": "Make a save offer",
      "tool": "Claude",
      "owner": "deal-agent",
      "crm": "crm_propose_save_offer",
      "next": "9.12",
      "when": "$.connect.save_offer ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "9.12",
      "phase": "P9",
      "kind": "action",
      "verb": "Approve save offer",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_decide_save_offer",
      "next": "9.D",
      "when": "$.connect.save_offer ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "9.13",
      "phase": "P9",
      "kind": "action",
      "verb": "Choose the path",
      "tool": "CRM",
      "owner": "deal-agent",
      "crm": "crm_start_path",
      "next": "9.14",
      "status": "tested"
    },
    {
      "id": "9.14",
      "phase": "P9",
      "kind": "action",
      "verb": "Move along the path",
      "tool": "CRM",
      "owner": "deal-agent",
      "crm": "crm_advance_path",
      "status": "tested"
    },
    {
      "id": "9.15",
      "phase": "P9",
      "kind": "action",
      "verb": "Do a path step by hand",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_complete_path_block",
      "next": "9.14",
      "status": "tested"
    },
    {
      "id": "9.16",
      "phase": "P9",
      "kind": "action",
      "verb": "Price the quote",
      "tool": "Ogma Quote",
      "owner": "deal-agent",
      "crm": "crm_price_quote",
      "next": "9.17",
      "status": "built"
    },
    {
      "id": "9.17",
      "phase": "P9",
      "kind": "action",
      "verb": "Approve the quote",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_decide_quote",
      "next": "9.18",
      "status": "built"
    },
    {
      "id": "9.18",
      "phase": "P9",
      "kind": "action",
      "verb": "Send the quote page",
      "tool": "Gmail",
      "owner": "deal-agent",
      "crm": "crm_send_quote",
      "next": "9.19",
      "status": "built"
    },
    {
      "id": "9.19",
      "phase": "P9",
      "kind": "action",
      "verb": "Record the acceptance",
      "tool": "Ogma Quote",
      "alternatives": [
        "Documenso"
      ],
      "owner": "deal-agent",
      "crm": "crm_accept_quote",
      "next": "9.D",
      "status": "built"
    },
    {
      "id": "9.20",
      "phase": "P9",
      "kind": "crm_write",
      "verb": "Record payment",
      "tool": "Stripe",
      "owner": "deal-agent",
      "crm": "crm_record_payment",
      "status": "tested"
    },
    {
      "id": "9.21",
      "phase": "P9",
      "kind": "crm_write",
      "verb": "Make payment link",
      "tool": "Stripe",
      "owner": "deal-agent",
      "crm": "crm_payment_link_for_quote",
      "status": "tested"
    },
    {
      "id": "9.22",
      "phase": "P9",
      "kind": "engine",
      "verb": "Follow up on quote views",
      "tool": "Claude",
      "owner": "deal-agent",
      "crm": "crm_create_task",
      "status": "built"
    },
    {
      "id": "9.23",
      "phase": "P9",
      "kind": "crm_read",
      "verb": "Score deal health",
      "tool": "CRM",
      "owner": "deal-agent",
      "crm": "crm_deal_health",
      "status": "tested"
    },
    {
      "id": "9.24",
      "phase": "P9",
      "kind": "crm_read",
      "verb": "Forecast the month",
      "tool": "CRM",
      "owner": "deal-agent",
      "crm": "crm_forecast",
      "status": "tested"
    },
    {
      "id": "9.25",
      "phase": "P9",
      "kind": "action",
      "verb": "Route the path",
      "tool": "CRM",
      "owner": "deal-agent",
      "crm": "crm_time_out_path",
      "next": "9.14",
      "status": "tested"
    },
    {
      "id": "9.26",
      "phase": "P9",
      "kind": "action",
      "verb": "Send a question flow",
      "tool": "Ogma Quote",
      "owner": "deal-agent",
      "crm": "crm_send_quote_flow",
      "next": "9.27",
      "status": "tested"
    },
    {
      "id": "9.27",
      "phase": "P9",
      "kind": "crm_write",
      "verb": "Record answers",
      "tool": "Ogma Quote",
      "owner": "deal-agent",
      "crm": "crm_save_quote_answers",
      "status": "tested"
    },
    {
      "id": "9.28",
      "phase": "P9",
      "kind": "action",
      "verb": "Answer a question in the portal or chat",
      "tool": "Ogma Quote",
      "owner": "deal-agent",
      "crm": "crm_record_assistant_answer",
      "status": "tested"
    },
    {
      "id": "9.30",
      "phase": "P9",
      "kind": "action",
      "verb": "Send a document",
      "tool": "Gmail",
      "owner": "deal-agent",
      "crm": "crm_path_send_document",
      "next": "4.10",
      "status": "tested"
    },
    {
      "id": "9.31",
      "phase": "P9",
      "kind": "action",
      "verb": "Make an offer",
      "tool": "Gmail",
      "owner": "deal-agent",
      "crm": "crm_path_make_offer",
      "next": "4.10",
      "status": "tested"
    },
    {
      "id": "9.W",
      "phase": "P9",
      "kind": "crm_write",
      "verb": "Update deal stage",
      "tool": "Claude CRM connector",
      "owner": "deal-agent",
      "crm": "crm_upsert_deal",
      "status": "tested"
    },
    {
      "id": "10.R",
      "phase": "P10",
      "kind": "crm_read",
      "verb": "Read due records",
      "tool": "Claude CRM connector",
      "owner": "relationship-agent",
      "crm": "crm_due_nurture",
      "status": "tested"
    },
    {
      "id": "10.0",
      "phase": "P10",
      "kind": "action",
      "verb": "Pick due actions",
      "tool": "Claude",
      "owner": "ops-agent",
      "status": "tested"
    },
    {
      "id": "10.1",
      "phase": "P10",
      "kind": "action",
      "verb": "Send market note",
      "tool": "Resend",
      "alternatives": [
        "Beehiiv"
      ],
      "owner": "relationship-agent",
      "status": "tested"
    },
    {
      "id": "10.2",
      "phase": "P10",
      "kind": "action",
      "verb": "Re-enter sequence",
      "tool": "CRM",
      "owner": "relationship-agent",
      "crm": "crm_enrol",
      "next": "4.R",
      "status": "built"
    },
    {
      "id": "10.3",
      "phase": "P10",
      "kind": "action",
      "verb": "Ask for referral",
      "tool": "Gmail",
      "owner": "relationship-agent",
      "status": "tested"
    },
    {
      "id": "10.4",
      "phase": "P10",
      "kind": "action",
      "verb": "Thank referrer",
      "tool": "Gmail",
      "owner": "relationship-agent",
      "status": "tested"
    },
    {
      "id": "10.5",
      "phase": "P10",
      "kind": "action",
      "verb": "Ask for review",
      "tool": "Gmail",
      "owner": "relationship-agent",
      "status": "tested"
    },
    {
      "id": "10.6",
      "phase": "P10",
      "kind": "action",
      "verb": "Report channel metrics",
      "tool": "Claude",
      "owner": "ops-agent",
      "crm": "v_channel_metrics",
      "status": "tested"
    },
    {
      "id": "10.7",
      "phase": "P10",
      "kind": "action",
      "verb": "Run A/B test",
      "tool": "CRM",
      "owner": "ops-agent",
      "crm": "crm_decide_experiment",
      "status": "built"
    },
    {
      "id": "10.8",
      "phase": "P10",
      "kind": "action",
      "verb": "Review outcomes",
      "tool": "Claude",
      "owner": "ops-agent",
      "status": "tested"
    },
    {
      "id": "10.9",
      "phase": "P10",
      "kind": "action",
      "verb": "Update playbook",
      "tool": "Claude Docs",
      "owner": "ops-agent",
      "next": "0.3",
      "status": "tested"
    },
    {
      "id": "10.10",
      "phase": "P10",
      "kind": "action",
      "verb": "Make a ReConnect offer",
      "tool": "Claude",
      "owner": "relationship-agent",
      "crm": "crm_record_reconnect_offer",
      "next": "4.10",
      "when": "$.reconnect.offers ? (@.enabled == true)",
      "status": "tested"
    },
    {
      "id": "10.11",
      "phase": "P10",
      "kind": "action",
      "verb": "Return to Connect",
      "tool": "CRM",
      "owner": "relationship-agent",
      "crm": "crm_reconnect_return",
      "next": "6.R",
      "status": "tested"
    },
    {
      "id": "10.12",
      "phase": "P10",
      "kind": "action",
      "verb": "Learn voice from edits",
      "tool": "Claude",
      "owner": "ops-agent",
      "crm": "crm_voice_examples",
      "status": "built"
    },
    {
      "id": "10.13",
      "phase": "P10",
      "kind": "action",
      "verb": "Send WhatsApp update",
      "tool": "WhatsApp Cloud API",
      "owner": "relationship-agent",
      "check": "opt-in only",
      "crm": "crm_decide_whatsapp_update",
      "next": "4.10",
      "when": "$.channels.whatsapp ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "10.14",
      "phase": "P10",
      "kind": "action",
      "verb": "Plan a follow-up from past conversations",
      "tool": "Claude",
      "owner": "relationship-agent",
      "crm": "crm_queue_message",
      "next": "4.10",
      "status": "built"
    },
    {
      "id": "10.15",
      "phase": "P10",
      "kind": "action",
      "verb": "Spoken to before: choose who to follow up",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_plan_follow_ups",
      "status": "built"
    },
    {
      "id": "10.16",
      "phase": "P10",
      "kind": "action",
      "verb": "Spot a contact who has moved job",
      "tool": "Companies House API",
      "alternatives": [
        "Ogma prospect database"
      ],
      "owner": "relationship-agent",
      "crm": "crm_suggest_move",
      "status": "built"
    },
    {
      "id": "10.17",
      "phase": "P10",
      "kind": "action",
      "verb": "Follow a contact to their new firm",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_decide_move",
      "status": "built"
    },
    {
      "id": "10.18",
      "phase": "P10",
      "kind": "action",
      "verb": "Share something of value",
      "tool": "Claude",
      "owner": "relationship-agent",
      "crm": "crm_outreach_asset_plan",
      "next": "4.10",
      "when": "$.reconnect.assets ? (@.enabled == true)",
      "status": "spec"
    },
    {
      "id": "10.19",
      "phase": "P10",
      "kind": "action",
      "verb": "Check how it went before the review ask",
      "tool": "Email",
      "alternatives": [
        "WhatsApp"
      ],
      "owner": "listings-agent",
      "check": "DMCC fake reviews rules (no review gating)",
      "crm": "crm_record_happiness",
      "next": "4.10",
      "when": "$.reviews.happiness ? (@.enabled == true)",
      "status": "built"
    },
    {
      "id": "10.20",
      "phase": "P10",
      "kind": "action",
      "verb": "Warn when a search's replies drop",
      "tool": "Rules",
      "owner": "ops-agent",
      "crm": "crm_raise_search_prompt",
      "status": "tested"
    },
    {
      "id": "10.21",
      "phase": "P10",
      "kind": "crm_read",
      "verb": "Measure results per signal pack",
      "tool": "CRM screens",
      "owner": "ops-agent",
      "crm": "crm_find_pack_results",
      "status": "built"
    },
    {
      "id": "10.22",
      "phase": "P10",
      "kind": "action",
      "verb": "Add firms you know to their campaigns",
      "tool": "Rules",
      "owner": "relationship-agent",
      "crm": "crm_known_campaigns_run",
      "next": "10.14",
      "status": "built"
    },
    {
      "id": "10.23",
      "phase": "P10",
      "kind": "action",
      "verb": "Learn what wins",
      "tool": "Rules",
      "alternatives": [
        "Claude"
      ],
      "owner": "outreach-agent",
      "crm": "crm_save_learning",
      "next": "4.2",
      "status": "tested"
    },
    {
      "id": "10.24",
      "phase": "P10",
      "kind": "action",
      "verb": "Look over what Ogma learned",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_set_lesson_status",
      "status": "tested"
    },
    {
      "id": "10.25",
      "phase": "P10",
      "kind": "action",
      "verb": "Pool results across the sector",
      "tool": "Rules",
      "owner": "outreach-agent",
      "crm": "crm_refresh_sector_stats",
      "next": "10.23",
      "status": "tested"
    },
    {
      "id": "10.W",
      "phase": "P10",
      "kind": "crm_write",
      "verb": "Log nurture touch",
      "tool": "Claude CRM connector",
      "owner": "relationship-agent",
      "status": "built"
    },
    {
      "id": "E1",
      "phase": "E",
      "kind": "engine",
      "verb": "Route real-time events",
      "tool": "Edge Function",
      "owner": "ops-agent",
      "crm": "crm_due_task_counts",
      "status": "built"
    },
    {
      "id": "E2",
      "phase": "E",
      "kind": "engine",
      "verb": "Match identities across channels",
      "tool": "CRM",
      "owner": "ops-agent",
      "crm": "crm_match_identity",
      "status": "tested"
    },
    {
      "id": "E3",
      "phase": "E",
      "kind": "engine",
      "verb": "Run agents on schedule",
      "tool": "Ogma engine server",
      "owner": "ops-agent",
      "crm": "crm_start_run",
      "status": "built"
    },
    {
      "id": "E4",
      "phase": "E",
      "kind": "engine",
      "verb": "Trigger stage automations",
      "tool": "CRM workflows",
      "owner": "ops-agent",
      "crm": "crm_set_stage",
      "status": "tested"
    },
    {
      "id": "E5",
      "phase": "E",
      "kind": "engine",
      "verb": "Rotate sending inboxes",
      "tool": "CRM",
      "owner": "ops-agent",
      "crm": "crm_mailbox_capacity",
      "status": "tested"
    },
    {
      "id": "E6",
      "phase": "E",
      "kind": "engine",
      "verb": "Monitor bounce and spam rates",
      "tool": "engine",
      "owner": "ops-agent",
      "crm": "crm_channel_paused",
      "status": "built"
    },
    {
      "id": "E7",
      "phase": "E",
      "kind": "engine",
      "verb": "Alert when a channel goes quiet",
      "tool": "engine",
      "owner": "ops-agent",
      "crm": "crm_health_alerts",
      "status": "built"
    },
    {
      "id": "E8",
      "phase": "E",
      "kind": "engine",
      "verb": "Sample-check AI messages",
      "tool": "Claude",
      "owner": "ops-agent",
      "crm": "crm_record_quality_check",
      "status": "tested"
    },
    {
      "id": "E9",
      "phase": "E",
      "kind": "crm_write",
      "verb": "Erase a person on request",
      "tool": "CRM",
      "owner": "ops-agent",
      "crm": "crm_erase_person",
      "status": "tested"
    },
    {
      "id": "E10",
      "phase": "E",
      "kind": "engine",
      "verb": "Apply data retention",
      "tool": "engine",
      "owner": "ops-agent",
      "crm": "crm_apply_retention",
      "status": "tested"
    },
    {
      "id": "E11",
      "phase": "E",
      "kind": "engine",
      "verb": "Alert the owner",
      "tool": "Gmail",
      "owner": "ops-agent",
      "crm": "crm_claim_alert",
      "status": "tested"
    },
    {
      "id": "E12",
      "phase": "E",
      "kind": "engine",
      "verb": "Track AI spend and quality",
      "tool": "engine",
      "owner": "ops-agent",
      "crm": "crm_model_spend",
      "status": "tested"
    },
    {
      "id": "E13",
      "phase": "E",
      "kind": "engine",
      "verb": "Earn autonomy",
      "tool": "engine",
      "owner": "ops-agent",
      "crm": "crm_autonomy_stats",
      "status": "tested"
    },
    {
      "id": "E14",
      "phase": "E",
      "kind": "engine",
      "verb": "Enforce spending caps",
      "tool": "engine",
      "owner": "ops-agent",
      "crm": "crm_budget_check",
      "status": "tested"
    },
    {
      "id": "E15",
      "phase": "E",
      "kind": "crm_read",
      "verb": "Show process and sign-offs",
      "tool": "CRM screens",
      "owner": "human",
      "crm": "crm_process_map",
      "status": "tested"
    },
    {
      "id": "E16",
      "phase": "E",
      "kind": "engine",
      "verb": "Seed the prospect database",
      "tool": "Reference agent",
      "owner": "ops-agent",
      "crm": "crm_ref_upsert_firm",
      "status": "built"
    },
    {
      "id": "E17",
      "phase": "E",
      "kind": "engine",
      "verb": "Refresh the prospect database weekly",
      "tool": "Reference agent",
      "owner": "ops-agent",
      "crm": "crm_ref_set_status",
      "status": "built"
    },
    {
      "id": "E18",
      "phase": "E",
      "kind": "crm_read",
      "verb": "Flag changes to picked firms",
      "tool": "CRM",
      "owner": "sourcing-agent",
      "crm": "crm_ref_changes",
      "status": "built"
    },
    {
      "id": "E19",
      "phase": "E",
      "kind": "crm_write",
      "verb": "Record Ogma-wide do-not-contact",
      "tool": "CRM screens",
      "owner": "human",
      "human": true,
      "crm": "crm_ref_suppress",
      "status": "built"
    },
    {
      "id": "E20",
      "phase": "E",
      "kind": "engine",
      "verb": "Load company registers in bulk",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_merge_companies",
      "status": "built"
    },
    {
      "id": "E21",
      "phase": "E",
      "kind": "engine",
      "verb": "Load officers and owners",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_merge_roles",
      "status": "built"
    },
    {
      "id": "E22",
      "phase": "E",
      "kind": "engine",
      "verb": "Record verified work emails",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_record_email",
      "status": "built"
    },
    {
      "id": "E23",
      "phase": "E",
      "kind": "crm_read",
      "verb": "Find the people at a firm",
      "tool": "CRM",
      "owner": "sourcing-agent",
      "crm": "crm_find_people",
      "status": "built"
    },
    {
      "id": "E24",
      "phase": "E",
      "kind": "crm_write",
      "verb": "Record a person's Find opt-out",
      "tool": "CRM",
      "owner": "ops-agent",
      "crm": "crm_find_opt_out",
      "status": "built"
    },
    {
      "id": "E25",
      "phase": "E",
      "kind": "engine",
      "verb": "Delete people no source still shows",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_apply_retention",
      "status": "built"
    },
    {
      "id": "E26",
      "phase": "E",
      "kind": "engine",
      "verb": "Collect candidate websites for firms",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_web_candidates",
      "status": "built"
    },
    {
      "id": "E27",
      "phase": "E",
      "kind": "engine",
      "verb": "Crawl a domain once",
      "tool": "Find worker",
      "owner": "ops-agent",
      "status": "built"
    },
    {
      "id": "E28",
      "phase": "E",
      "kind": "engine",
      "verb": "Extract facts from a crawl",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_record_site_numbers",
      "status": "built"
    },
    {
      "id": "E29",
      "phase": "E",
      "kind": "engine",
      "verb": "Match a website to a firm",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_record_web_results",
      "status": "built"
    },
    {
      "id": "E46",
      "phase": "E",
      "kind": "engine",
      "verb": "Crawl a matched firm's own website and keep its pages",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_record_site_crawls",
      "status": "built"
    },
    {
      "id": "E47",
      "phase": "E",
      "kind": "engine",
      "verb": "Load Companies House accounts in bulk",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_record_accounts",
      "status": "built"
    },
    {
      "id": "E47b",
      "phase": "E",
      "kind": "engine",
      "verb": "Find accounts gaps and late filers",
      "tool": "Find worker (Companies House API) and a Claude Code session for PDF accounts",
      "owner": "ops-agent",
      "crm": "crm_find_record_accounts_gaps",
      "status": "built"
    },
    {
      "id": "E48",
      "phase": "E",
      "kind": "engine",
      "verb": "Load dissolved companies",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_merge_companies",
      "status": "built"
    },
    {
      "id": "E49",
      "phase": "E",
      "kind": "engine",
      "verb": "Load other registers for firms and trading names",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_merge_charities",
      "status": "built"
    },
    {
      "id": "E50",
      "phase": "E",
      "kind": "engine",
      "verb": "Settle uncertain website matches by checking each site again",
      "tool": "Find worker and Claude Haiku 5.5 (own daily cap)",
      "owner": "ops-agent",
      "crm": "crm_find_record_web_results",
      "status": "built"
    },
    {
      "id": "E51",
      "phase": "E",
      "kind": "engine",
      "verb": "Load Overture Maps places and give linked firms their websites",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_websites_from_establishments",
      "status": "built"
    },
    {
      "id": "E54",
      "phase": "E",
      "kind": "engine",
      "verb": "Suggest websites from group companies",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_reviews_from_groups",
      "status": "built"
    },
    {
      "id": "E57",
      "phase": "E",
      "kind": "engine",
      "verb": "Watch unsubscribe and complaint signals",
      "tool": "CRM",
      "owner": "ops-agent",
      "crm": "crm_pause_mailbox",
      "status": "built"
    },
    {
      "id": "E58",
      "phase": "E",
      "kind": "engine",
      "verb": "Check sending domains against blocklists",
      "tool": "DNS blocklists",
      "owner": "ops-agent",
      "crm": "crm_record_blocklist_check",
      "status": "built"
    },
    {
      "id": "E53",
      "phase": "E",
      "kind": "engine",
      "verb": "Describe listed premises as businesses",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_classify_establishments",
      "status": "built"
    },
    {
      "id": "E52",
      "phase": "E",
      "kind": "engine",
      "verb": "Route help requests to Ogma's team",
      "tool": "Resend",
      "alternatives": [
        "Webhook"
      ],
      "owner": "ops-agent",
      "crm": "crm_help_mark_notified",
      "status": "tested"
    },
    {
      "id": "E55",
      "phase": "E",
      "kind": "engine",
      "verb": "Run the fast lane for enquiries every minute",
      "tool": "Ogma engine server",
      "owner": "inbox-agent",
      "crm": "crm_fast_lane_work",
      "status": "built"
    },
    {
      "id": "E56",
      "phase": "E",
      "kind": "engine",
      "verb": "Measure speed to lead",
      "tool": "CRM screens",
      "owner": "ops-agent",
      "crm": "crm_speed_to_lead",
      "status": "built"
    },
    {
      "id": "E42",
      "phase": "E",
      "kind": "action",
      "verb": "Check a business phone against TPS and CTPS",
      "tool": "TPS file",
      "owner": "outreach-agent",
      "crm": "crm_record_phone_check",
      "status": "tested"
    },
    {
      "id": "E59",
      "phase": "E",
      "kind": "engine",
      "verb": "Expire outreach assets",
      "tool": "CRM",
      "owner": "ops-agent",
      "crm": "crm_expire_outreach_assets",
      "status": "built"
    },
    {
      "id": "E60",
      "phase": "E",
      "kind": "engine",
      "verb": "Read company numbers on listed businesses' websites",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_record_site_numbers",
      "status": "built"
    },
    {
      "id": "E61",
      "phase": "E",
      "kind": "engine",
      "verb": "Check Meta connections and renew tokens",
      "tool": "Meta Graph API",
      "owner": "ops-agent",
      "crm": "crm_meta_connections",
      "status": "built"
    },
    {
      "id": "E62",
      "phase": "E",
      "kind": "engine",
      "verb": "Measure owner minutes",
      "tool": "CRM screens",
      "owner": "ops-agent",
      "crm": "crm_owner_minutes",
      "status": "built"
    },
    {
      "id": "E63",
      "phase": "E",
      "kind": "engine",
      "verb": "Load a market's businesses from map listings",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_ref_upsert_firm",
      "status": "built"
    },
    {
      "id": "E64",
      "phase": "E",
      "kind": "engine",
      "verb": "Profile firms from their own websites",
      "tool": "Claude Haiku 5.5",
      "alternatives": [
        "Jev (TypeSafe)"
      ],
      "owner": "ops-agent",
      "crm": "crm_find_record_profiles",
      "status": "built"
    },
    {
      "id": "E65",
      "phase": "E",
      "kind": "engine",
      "verb": "Add businesses with no company number from their websites",
      "tool": "Jev (TypeSafe)",
      "owner": "ops-agent",
      "crm": "crm_find_listing_firm_candidates",
      "status": "built"
    },
    {
      "id": "E66",
      "phase": "E",
      "kind": "engine",
      "verb": "Find websites by web search for firms with staff",
      "tool": "Serper (Google results)",
      "owner": "ops-agent",
      "crm": "crm_find_search_candidates",
      "status": "built"
    },
    {
      "id": "E67",
      "phase": "E",
      "kind": "engine",
      "verb": "Read the UK domain list for company numbers",
      "tool": "Common Crawl index and Nominet zone files",
      "owner": "ops-agent",
      "crm": "crm_find_add_listed_domains, crm_find_listed_domains",
      "status": "built"
    },
    {
      "id": "E68",
      "phase": "E",
      "kind": "engine",
      "verb": "Match websites with no company number to their companies",
      "tool": "Trained matcher (numpy)",
      "owner": "ops-agent",
      "crm": "crm_find_sitematch_candidates, crm_find_record_web_results",
      "status": "built"
    },
    {
      "id": "E43",
      "phase": "E",
      "kind": "engine",
      "verb": "Record firm signals",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_ref_record_signal",
      "status": "built"
    },
    {
      "id": "E44",
      "phase": "E",
      "kind": "engine",
      "verb": "Re-check a cited signal before drafting and sending",
      "tool": "Code",
      "owner": "outreach-agent",
      "crm": "crm_firm_reason_state, crm_cancel_stale_reason",
      "status": "built"
    },
    {
      "id": "E69",
      "phase": "E",
      "kind": "engine",
      "verb": "Check firms' email and website security",
      "tool": "DNS over HTTPS",
      "owner": "ops-agent",
      "crm": "crm_find_security_candidates, crm_find_record_domain_security",
      "status": "built"
    },
    {
      "id": "E70",
      "phase": "E",
      "kind": "engine",
      "verb": "Score firms' websites from their stored pages",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_web_quality_candidates, crm_ref_record_signal",
      "status": "built"
    },
    {
      "id": "E71",
      "phase": "E",
      "kind": "engine",
      "verb": "Record Cyber Essentials certificates",
      "tool": "IASME certificate search",
      "owner": "ops-agent",
      "crm": "crm_ref_record_signal",
      "status": "spec"
    },
    {
      "id": "E73",
      "phase": "E",
      "kind": "engine",
      "verb": "Load the ICO register of fee payers",
      "tool": "ICO open data",
      "owner": "ops-agent",
      "crm": "crm_ref_record_signal",
      "status": "spec"
    },
    {
      "id": "E74",
      "phase": "E",
      "kind": "engine",
      "verb": "Label firms from their stored pages",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_sync_labels, crm_find_label_candidates, crm_find_record_labels",
      "status": "built"
    },
    {
      "id": "E75",
      "phase": "E",
      "kind": "engine",
      "verb": "Estimate firms' staff and turnover",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_refresh_benchmarks, crm_find_refresh_search_firms",
      "status": "built"
    },
    {
      "id": "E76",
      "phase": "E",
      "kind": "engine",
      "verb": "Record firms' accountants",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_refresh_advisers, crm_find_record_corporate_secretaries",
      "status": "built"
    },
    {
      "id": "E77",
      "phase": "E",
      "kind": "engine",
      "verb": "Count each adviser firm's clients by sector",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_find_refresh_adviser_clients",
      "status": "built"
    },
    {
      "id": "E78",
      "phase": "E",
      "kind": "engine",
      "verb": "Read each mailbox's signature and own sending",
      "tool": "Gmail API",
      "owner": "ops-agent",
      "crm": "crm_mailbox_profiles, crm_record_mailbox_profile",
      "status": "built"
    },
    {
      "id": "E79",
      "phase": "E",
      "kind": "engine",
      "verb": "Label industry sources' audience and what they accept",
      "tool": "Claude",
      "owner": "ops-agent",
      "crm": "crm_ref_label_industry_sources",
      "status": "built"
    },
    {
      "id": "E80",
      "phase": "E",
      "kind": "engine",
      "verb": "Harvest who the industry sources name",
      "tool": "Find worker",
      "alternatives": [
        "Claude"
      ],
      "owner": "ops-agent",
      "crm": "crm_ref_match_industry_names, crm_ref_add_industry_source_names, crm_ref_add_industry_source_firms",
      "status": "built"
    },
    {
      "id": "E81",
      "phase": "E",
      "kind": "engine",
      "verb": "Find firms that sell to a buyer niche",
      "tool": "Find worker",
      "alternatives": [
        "Claude"
      ],
      "owner": "ops-agent",
      "crm": "crm_ref_firm_buyers_from_sources, crm_ref_record_firm_buyers",
      "status": "built"
    },
    {
      "id": "E82",
      "phase": "E",
      "kind": "engine",
      "verb": "Tag firms with their primary and secondary sectors",
      "tool": "Jev (TypeSafe)",
      "owner": "ops-agent",
      "crm": "crm_ref_fill_primary_taxonomy, crm_ref_record_firm_taxonomy, crm_ref_clear_firm_tags",
      "status": "built"
    },
    {
      "id": "E83",
      "phase": "E",
      "kind": "engine",
      "verb": "Map how far Find's data reaches",
      "tool": "Find worker",
      "owner": "ops-agent",
      "crm": "crm_ref_coverage_map_slice, crm_ref_coverage_map",
      "status": "built"
    },
    {
      "id": "E72",
      "phase": "E",
      "kind": "crm_read",
      "verb": "Export a view",
      "tool": "CRM",
      "owner": "supervisor",
      "crm": "crm_list_records",
      "status": "tested"
    }
  ]
};
